import BUILDING_INSPECTION from './buildingInspection';
import ENERGY_LABEL_LEADS from './energyLabelLeads';

const SWEDISH = {
  type: 'sv-SE',
  languageNames: {
    en: 'Engelska',
    no: 'Norska',
    nb: 'Norska',
    de: 'Tyska',
    fr: 'Franska',
    sv: 'Svenska',
    se: 'Svenska',
    da: 'Danska',
    it: 'Italienska',
    fi: 'Finska',
  },
  global: {
    noDataAvailable: 'Ingen data tillgänglig',
    move: 'Flytta',
    rotate: 'Rotera',
    model: 'Modell',
    data: 'Data',
    all: 'Alla',
    controls: 'Styrning',
    lastUpdated: 'Senast uppdaterad',
    noData: 'Inga data',
    custom: 'Anpassad',
    name: 'Namn',
    setpoints: 'Setpoints',
    email: 'E-post',
    date: 'Datum',
    timestamp: 'Tidpunkt',
    address: 'Adress',
    street: 'Gata',
    postcode: 'Postnummer',
    city: 'Stad',
    country: 'Land',
    language: 'Språk',
    add: 'Lägg till',
    timezone: 'Tidszon',
    new: 'Ny',
    from: 'Från',
    until: 'Till',
    selectStartDate: 'Välj startdatum',
    selectEndDate: 'välj slutdatum',
    copied: 'Kopierat',
    average: 'Snitt',
    min: 'Min',
    max: 'Max',
    last: 'Senaste',
    type: 'Typ',
    role: 'Roll',
    category: 'Kategori',
    description: 'Beskrivning',
    status: 'Status',
    public: 'Publik',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    hidden: 'Dold',
    visible: 'Synlig',
    show: 'Visa',
    hide: 'Dölj',
    enabled: 'Aktiverad',
    disabled: 'Inaktiverad',
    actionRequired: 'Åtgärd krävs',
    success: 'Lyckades',
    none: 'Ingen',
    error: 'Fel',
    basicInfo: 'Grundläggande information',
    information: 'Information',
    display: 'Visning',
    save: 'Spara',
    saving: 'Sparar…',
    saveSuccess: 'Sparad',
    saveError: 'Det gick inte att spara',
    search: 'Sök',
    confirm: 'Bekräfta',
    yes: 'Ja',
    no: 'Nej',
    close: 'Stäng',
    cancel: 'Avbryt',
    update: 'Uppdatera',
    updating: 'Uppdaterar...',
    undo: 'Ångra',
    done: 'Klar',
    delete: 'Radera',
    discard: 'Ignorera',
    rename: 'Byt namn',
    editName: 'Redigera namn',
    open: 'Öppna',
    download: 'Ladda ner',
    password: 'Lösenord',
    login: 'Logga in',
    loginWithAzure: 'Logga in med Azure',
    invalidCredentials: 'Ogiltiga inloggningsuppgifter',
    loginTooManyAttempts:
      'För många inloggningsförsök, försök igen om några minuter',
    loginInactiveUser: 'Detta användarkonto är inte längre aktivt',
    loginUnavailable: 'Det gick inte att logga in just nu, försök igen senare',
    welcome: 'Välkommen till Sastech',
    loginSubtitle: 'Logga in för att komma åt din instrumentpanel',
    or: 'eller',
    key: 'Nyckel',
    back: 'Tillbaka',
    apply: 'Använd',
    inDevelopement: 'Under utveckling',
    notAuthorized: 'Ej auktoriserad',
    heating: 'Värme',
    cooling: 'Kylning',
    ventilation: 'Ventilation',
    climate: 'Inomhusklimat',
    battery: 'Batteri',
    batteries: 'Batterier',
    capabilities: 'Funktioner',
    moveTo: 'Flytta till',
    building: 'Byggnad',
    buildings: 'Byggnader',
    floor: 'Våning',
    floors: 'Våningar',
    sensors: 'Sensorer',
    sensor: 'Sensor',
    controller: 'Styrenhet',
    energySource: 'Energikälla',
    session: 'Session',
    addDevice: 'Lägg till enhet',
    device: 'Enhet',
    devices: 'Enheter',
    selectDevice: 'Välj en enhet',
    edit: 'Redigera',
    serialNumber: 'Serienummer',
    trash: 'Papperskorg',
    emptyTrash: 'Töm papperskorgen',
    actions: 'Åtgärder',
    restore: 'Återställ',
    selectCategory: 'Välj...',
    create: 'Skapa',
    monthChartText: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'Maj',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Dec',
    ],
    today: 'Idag',
    weekdaysShort: ['Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör', 'Sön'],
    weekdays: [
      'Söndag',
      'Måndag',
      'Tisdag',
      'Onsdag',
      'Torsdag',
      'Fredag',
      'Lördag',
    ],
    title: 'Titel',
    to: 'till',
    remove: 'Ta bort',
    inspect: 'Inspektera',
    compare: 'Jämför',
    export: 'Exportera',
    total: 'Totalt',
    activate: 'Aktivera',
    color: 'Färg',
    text: 'Text',
    link: 'Länk',
    frame: 'Ram',
    info: 'Info',
    saveChanges: 'Spara ändringar',
    sidebarMenu: 'Sidomeny',
    icons: 'Ikoner',
    ok: 'OK',
    exit: 'Stäng',
    exportImage: 'Exportera bild',
    exportSelected: 'Exportera valda',
    directions: {
      top: 'Topp',
      bottom: 'Botten',
      right: 'Höger',
      left: 'Vänster',
      front: 'Front',
      back: 'Bak',
      isometric: 'Isometrisk',
    },
    switchVendor: 'Byt kund',
    searchVendors: 'Sök kunder...',
    noVendorsFound: 'Inga kunder hittades',
  },
  chart: {
    zoomIn: 'Zooma in',
    zoomOut: 'Zooma ut',
    rotate: 'Rotera',
    fullscreen: 'Helskärm',
    rotateTip: 'Klicka och dra för att rotera diagram',
  },
  data: {
    loading: 'Laddar...',
    loadingData: 'Laddar data...',
    noResults: 'Inga resultat hittades.',
    error: 'Fel',
    failedToLoadData: 'Kunde inte ladda data',
    noDataAvailable: 'Ingen data tillgänglig',
  },

  general: {
    temperature: 'Temperatur',
    co2: 'CO₂',
    humidity: 'Luftfuktighet',
    zone: 'Zon',
    data: 'Data',
    edit: 'Redigera',
    analyze: 'Analysera',
    chartType: 'Diagramtyp',
    toggleSeries: 'Växla serier',
    resetFilters: 'Återställ filter',
    exportData: 'Exportera data',
  },
  chat: {
    title: 'Sastech Chat',
    placeholder: 'Skriv ditt meddelande här…',
    send: 'Skicka',
    unknownUser: 'Okänd användare',
  },
  navigation: {
    dashboard: 'Instrumentpanel',
    eosDashboard: 'Översikt',
    devices: 'Enheter',
    map: 'Karta',
    buildings: 'Byggnader',
    reports: 'Rapporter',
    settings: 'Inställningar',
    logout: 'Logga ut',
    sastech: 'Sastech inställningar',
    analytics: 'Analys',
    buildings3D: 'Byggnader 3D',
    superSettings: 'Sastech',
    buildingInspection: 'Inspektion',
    expandSidebar: 'Expandera sidomenyn',
    collapseSidebar: 'Minimera sidomenyn',
    userCalendar: 'Användarkalender',
    energyLabelLeads: 'Energimärkning-leads',
  },
  reports: {
    title: 'Rapporter',
    orderReport: 'Beställ rapport',
    orderDescription: 'Rapporten dyker upp i listan när den är klar.',
    reportType: 'Rapporttyp',
    kinds: {
      eos_weekly: 'Veckorapport energi',
      eos_monthly: 'Månadsrapport energi',
    },
    period: 'Period',
    week: 'Vecka {week}',
    reportLanguage: 'Rapportspråk',
    submit: 'Beställ',
    submitting: 'Beställer…',
    status: {
      queued: 'I kö',
      generating: 'Skapas',
      completed: 'Klar',
      failed: 'Misslyckades',
    },
    exportExcel: 'Ladda ner Excel',
    exportPdf: 'Ladda ner PDF',
    makePdf: 'Skapa PDF',
    pdfPending: 'PDF skapas…',
    confirmDeleteTitle: 'Ta bort rapport',
    confirmDeleteMessage:
      'Rapporten tas bort från listan. Detta kan inte ångras.',
    noReports: 'Inga rapporter ännu. Beställ den första.',
    noSearchHits: 'Inga rapporter matchar sökningen.',
    noMeters: 'Byggnaden har inga aktiva energimätare.',
    duplicateOrder: 'Samma rapport skapas redan.',
    orderError: 'Kunde inte beställa rapporten',
    orderSuccess: 'Rapporten är beställd och skapas nu.',
    deleteError: 'Kunde inte ta bort rapporten',
    pdfError: 'Kunde inte beställa PDF',
    pdfRequested: 'PDF är beställd och skapas nu.',
    requestedBy: 'Beställd av',
    ordered: 'Beställd',
    daysAgo: '{count} dagar sedan',
    sheets: {
      summary: 'Sammanfattning',
      days: 'Per dag',
      hours: 'Per timme',
      sources: 'Mätare',
      profile: 'Dygnsprofil',
    },
    excel: {
      parameter: 'Parameter',
      value: 'Värde',
      unit: 'Enhet',
      delivered: 'Levererad energi',
      production: 'Egenproducerad',
      export: 'Exporterad',
      net: 'Använd i byggnaden',
      baseline: 'Baseline',
      previousYear: 'Föregående år',
      co2: 'CO2',
      baselineCo2: 'CO2 baseline',
      hoursWithData: 'Timmar med data',
      meanKW: 'Medeleffekt',
      maxKW: 'Högsta timme',
      maxAt: 'Högsta timme, tidpunkt',
      baseLoadKW: 'Baslast',
      nightKW: 'Nattlast 00–05',
      peakHours: 'Timmar på eller över 90 % av max',
      weekday: 'Veckodag',
      time: 'Timme',
      source: 'Mätare',
      missingHours: 'Saknade timmar',
      energy: 'Energi',
      co2Factor: 'CO2 faktor',
      role_delivered: 'levererad energi',
      role_production: 'egenproduktion',
      role_export: 'export',
      role_excluded: 'inte medräknad',
    },
  },
  map: {
    addBuildingAtCenter: 'Lägg till byggnad i kartans centrum',
  },
  pagination: {
    rowsPerPage: 'Rader per sida',
    rangeSeparator: 'av',
  },

  devices: {
    title: 'Enhetsöversikt',
    reset: 'Återställ',
    noDevices: 'Inga enheter hittades.',
    unnamed: 'Namnlös enhet',
    copySensorTag: 'Kopiera sensortagg',
    graph: {
      inspect: 'Inspektera',
      edit: 'Redigera',
      chartType: 'Diagramtyp',
      toggleSeries: 'Växla serier',
      resetFilters: 'Återställ filter',
      exportData: 'Exportera data',
      noData: 'Ingen data',
      bar: 'Stapel',
      line: 'Linje',
      pie: 'Cirkeldiagram',
      scatter: 'Spridning',
      radar: 'Radar',
    },
    categoryFilter: {
      filter: 'Filtrera',
      filterByCategory: 'Filtrera efter kategori',
      selectAll: 'Välj alla',
      clearAll: 'Rensa alla',
      searchCategories: 'Sök kategorier...',
      noCategories: 'Inga kategorier hittades',
      noData: 'Ingen data',
      devices: 'enheter',
      selected: 'Valda',
      category: 'kategori',
      categories: 'kategorier',
      more: 'fler',
    },
    detailLevel: {
      label: 'Detaljnivå',
      units: {
        minutes: 'Minuter',
        minutesShort: 'min',
        day: 'Dag',
      },
    },
    dateRange: {
      startLabel: 'Startdatum',
      endLabel: 'Slutdatum',
    },
    eosConsumption: {
      card: {
        dateLabel: 'Datum',
        total: {
          production: 'Total produktion:',
          consumption: 'Total förbrukning:',
        },
        highestPeak: 'Högsta topp:',
        calculatedPrice: {
          eur: 'Beräknat pris (EUR):',
          nok: 'Beräknat pris (NOK):',
        },
      },
    },
  },

  analytics: {
    session: {
      moreActions: 'Fler åtgärder',
      newSession: 'Ny session',
      unsaved: 'Osparade ändringar',
      namePlaceholder: 'Sessionsnamn',
      deleteTitle: 'Ta bort sessionen?',
      deleteDescription:
        'Detta tar permanent bort den sparade sessionen och dess enhetsurval.',
      noSessions: 'Inga sparade sessioner',
      discardTitle: 'Ignorera osparade ändringar?',
      discardDescription:
        'Den aktuella sessionen har ändringar som inte har sparats. Om du byter förlorar du dem.',
    },
    notifications: {
      overlayMissingZone:
        'Byggnaden har ingen zon konfigurerad. Använder standard (NO1).',
      overlayMissingRate: 'Kunde inte hämta valutakurs',
      overlayFetchFailed: 'Kunde inte hämta överläggsdata',
      sessionSaved: 'Sessionen har sparats',
      sessionCreated: 'Sessionen har skapats',
      sessionDeleted: 'Sessionen har tagits bort',
      sessionSaveFailed: 'Kunde inte spara sessionen',
      sessionDeleteFailed: 'Kunde inte ta bort sessionen',
      sessionsLoadFailed: 'Kunde inte hämta sparade sessioner',
      devicesLoadFailed: 'Kunde inte hämta enheter',
      buildingsLoadFailed: 'Kunde inte hämta byggnader',
      readingsLoadFailed:
        'Kunde inte hämta mätvärden för en eller flera enheter',
      nameRequired: 'Ge sessionen ett namn innan du sparar',
      rangeTooWide:
        'Perioder över 7 dagar är långsamma med detta intervall. Byt till Dagligen för bättre prestanda.',
    },
    title: 'Realtidsanalys & KPI:er',
    pageTitle: 'Analys',
    searchPlaceholder: 'Sök enheter…',
    buttons: {
      toggleSidebar: 'Visa/dölj enhetslista',
      showAll: 'Visa alla',
      hideAll: 'Dölj alla',
      showTrends: 'Visa trender',
      hideTrends: 'Dölj trender',
      clearAll: 'Rensa alla',
      export: 'Exportera',
    },
    exportMenu: {
      exportAsPNG: 'Exportera som PNG',
      exportAsCSV: 'Exportera som CSV',
    },
    thresholds: {
      max: 'Max:',
      min: 'Min:',
      aboveThreshold: 'Över tröskelvärde',
      belowThreshold: 'Under tröskelvärde',
    },
    timeAxis: {
      label: 'Tidsaxel',
      actual: 'Faktisk tid',
      timeOfDay: 'Tid på dygnet',
      dayOfWeek: 'Veckodag',
      dayOfMonth: 'Dag i månaden',
      bucket: 'Gruppera efter',
    },
    legend: {
      manage: 'Hantera',
      overlays: 'Överlägg',
      series: 'Serier',
      trends: 'Trender',
      more: 'fler',
    },
    overlay: {
      weatherAndElectricity: 'Väder & Elektricitet',
      none: 'Ingen',
      outsideTemperature: 'Utomhustemperatur',
      elecPrice: 'Elpris',
      elecPriceFull: 'Elpris (kr/kWh)',
      loadingData: 'Laddar data...',
    },
    collab: {
      viewingSession: 'tittar på den här sessionen',
      updatedSession: 'uppdaterade den här sessionen',
      deletedSession: 'raderade den här sessionen',
      conflictTitle: 'Någon har sparat en nyare version',
      conflictDescription:
        'Den här sessionen sparades av någon annan medan du redigerade. Ladda deras version (dina ändringar går förlorade) eller skriv över med din.',
      loadTheirs: 'Ladda deras version',
      overwrite: 'Skriv över',
    },
    picker: {
      wholeBuilding: 'Hela byggnaden',
      noClimateSources: 'Inga byggnader med zoner',
      noAveragesData: 'Inga klimatdata ännu',
      noIndoorSensors: 'Byggnaden har inga inomhussensorer',
      inSession: 'I sessionen',
      searchBuildings: 'Sök byggnader…',
      noBuildingsMatch: 'Inga byggnader matchar',
      noWeatherData: 'Inga väderdata ännu',
    },
    devices: {
      noDevicesMatch: 'Inga enheter matchar',
      unnamedDevice: 'Namnlös enhet',
      noDevicesSelected: 'Inga enheter valda',
      devicesFound: 'enheter hittade',
      noDevicesMatchSearch: 'Inga enheter matchar din sökning',
      deviceSelected: 'enhet vald',
      devicesSelected: 'enheter valda',
      shown: 'visas',
      total: 'totalt',
    },
    chart: {
      zoomHint: 'Zoomad (dubbelklicka för att återställa)',
      loadingChartData: 'Laddar diagramdata...',
      addDevicesToVisualize: 'Lägg till enheter för att visualisera data',
    },
    liveEvents: {
      title: 'Livehändelser',
      events: 'händelser',
      waitingForEvents: 'Väntar på händelser…',
    },
    modal: {
      weatherIntervalHint: 'Väderdata har timupplösning',
      deviceSettings: 'Enhetsinställningar',
      addDevices: 'Lägg till enheter',
      clear: 'Rensa',
      startTime: 'Starttid',
      endTime: 'Sluttid',
      samplingInterval: 'Samplingsintervall',
      dataAggregationGranularity: 'Dataaggregeringsgranularitet',
      startMustBeBeforeEnd: 'Start måste vara före slut',
      intervals: {
        fiveMinutes: '5 minuter',
        fifteenMinutes: '15 minuter',
        oneHour: '1 timme',
        daily: 'Dagligen',
      },
    },
    connectionStatus: {
      error: 'FEL',
      connected: 'ANSLUTEN',
      connecting: 'ANSLUTER',
      disconnected: 'FRÅNKOPPLAD',
    },
  },

  eosDashboard: {
    headerTitle: 'Energiöversikt',
    energyKnowledge: {
      title: 'Energianalys',
      lastMonth: 'Förra månaden',
    },
    building: 'Byggnad',
    selectBuilding: 'Välj byggnad',
    outdoorTemperature: 'Utomhustemperatur',
    noData: 'Saknas',
    electricityPrice: 'Elpris',
    electricityPrices: 'Elpriser',
    noPriceData: 'Inga prisdata tillgängliga.',
    electricityConsumption: 'Elförbrukning',
    baseline: 'Baslinje',
    viewLabel: 'Vy:',
    aggregated: 'Aggregerad',
    meteringPoint: 'Mätpunkt:',
    individualTitle: 'Individuella mätpunkter',
    eosSourcesTitle: 'Individuella EOS-enheter',
    footprint: 'CO₂-avtryck (reduktion)',
    co2Footprint: 'CO₂-avtryck',
    consumption: 'Förbrukning',
    avgMaxKwp: 'Genomsnittlig max kWp',
    higher: 'Högre',
    lower: 'Lägre',
    normal: 'Normal',
    priceWord: 'pris',
    vsAverage: 'Jämfört med snitt',

    baselineChart: {
      total: 'Totalt',
      average: 'Genomsnitt',
      leftAxis: 'kWh (Förbrukning)',
      rightAxis: 'kWp (Genomsnittligt max)',
      co2Avg: 'CO₂ Genomsnitt',
      missingData: 'Saknas data',
      missingDataDescription: 'Värden saknas för denna månad',
    },
    energyLabel: {
      title: 'Dynamisk energietikett',
      withoutSastech: 'Officiell etikett',
      withSastech: 'Dynamisk etikett',
      deliveredEnergy: 'Beräknad levererad energi',
      insufficientData:
        'Endast {months} månaders data tillgänglig. Etiketten kanske inte är representativ.',
      noFloorArea: 'Nettoanvändbar golvarea är inte angiven för denna byggnad.',
      noBuildingCategory: 'Byggnadskategori är inte angiven för denna byggnad.',
      fossilFuelShare: 'Andel el/olja/gas',
      reduction: 'Minskning',
      floorArea: 'Golvarea',
      annualConsumption: 'Årlig',
      energyGrade: 'Energiklass',
      labels: {
        A: 'Mycket energieffektiv',
        B: 'Energieffektiv',
        C: 'Måttlig effektivitet',
        D: 'Under genomsnittet',
        E: 'Dålig effektivitet',
        F: 'Mycket dålig effektivitet',
        G: 'Minst effektiv',
      },
    },
    kpiSection: {
      noChange: '0.0',

      units: {
        kWh: 'kWh',
        kg: 'kg',
        kgCo2: 'kg CO₂',
        krPerKWh: 'kr/kWh',
        degC: '°C',
      },

      trend: {
        increaseSign: '+{percent}%',
        decreaseSign: '-{percent}%',
        neutral: '0.0',
        aboveAverage: 'Över',
        belowAverage: 'Under',
        atAverage: 'Vid',
        averageThisPeriod: 'snitt denna period',
      },

      consumption: {
        title: 'Total förbrukning',
        value: '{value} {unit}',
        subtitle: {
          increased: 'Ökat med {delta} {unit}',
          reduced: 'Minskat med {delta} {unit}',
          noChange: 'Ingen förändring i förbrukning',
          noBaseline: 'Inga basdata tillgängliga',
        },
        detail: 'Energiförbrukning senaste {periodLabel}',
      },

      co2: {
        title: 'Totalt CO₂-avtryck',
        value: '{value} {unit}',
        subtitle: {
          reduced: 'Minskat med {delta} {unit}',
          increased: 'Ökat med {delta} {unit}',
          noChange: 'Ingen förändring i utsläpp',
          noBaseline: 'Inga basdata tillgängliga',
        },
        detail: 'Koldioxidavtryck senaste {periodLabel}',
      },

      adjustedConsumption: {
        title: 'Graddagsjusterad förbrukning',
      },

      estate: {
        title: 'Byggnader och källor',
        value: '{count} byggnader',
        subtitle: '{count} totala källor',
        detail: 'För närvarande {count} aktiva enheter',
      },

      price: {
        title: 'Aktuellt pris',
        value: '{value} {unit}',
        subtitle: '{direction} {avgPhrase}',
        detail: 'Elpris just nu',
      },

      temperature: {
        title: 'Temperatur',
        value: '{value}{unit}',
        chipDelta: '{signedDelta}{unit}',
        subtitleText: '{text}',
        detail: 'Aktuella väderförhållanden',
      },
    },
    savingsSection: {
      consumptionComparison: {
        title: 'Förbrukningsjämförelse - föregående år vs hittills i år',
        baseLineLabel: 'Baseline',
        peakHourlyLabel: 'Högsta topp',
      },
      consumptionSavings: {
        title: `Förbrukningsbesparing - baseline vs. {{currentYear}}`,
      },
    },
    electricityChart: {
      totalLabel: 'Totalt',
      totalEnergyConsumption: 'Total energiförbrukning',
      totalElectricityConsumption: 'Total elförbrukning',
      energyConsumption: 'Energiförbrukning',
      electricityConsumption: 'Elförbrukning',
      noDataForSelectedPeriod: 'Ingen data för vald period',
      meteringPointTitle: 'Mätpunkt: {id}',

      unknownLabel: 'Okänt',
      unknownIdLabel: 'Okänt ID',
      powerFactorLabel: 'Effektfaktor Cos φ',
      powerFactorWarning: 'Effektfaktor under 0,95 kan medföra tariffpåföljder',
      renameDialog: {
        title: 'Byt namn på mätpunkt',
        label: 'Visningsnamn',
        helpTextPrefix: 'Ursprungligt mätpunkts-ID',
      },
      errors: {
        loadAggregatedData: 'Det gick inte att läsa in aggregerade data',
        loadFilteredData: 'Det gick inte att läsa in filtrerade data',
        fetchDisplayName: 'Det gick inte att hämta visningsnamn',
        invalidDisplayName: 'Ange ett giltigt visningsnamn',
        renameFailed: 'Det gick inte att byta namn på EOS-enheten',
        renameUnknown: 'Ett fel uppstod vid namnbyte av EOS-enheten',
        noDataToExport: 'Ingen data tillgänglig för export',
        exportFailedTitle: 'Export misslyckades',
        exportFailedPrefix: 'Export av data misslyckades',
        unknownError: 'Okänt fel',
        enterValidDisplayName: 'Ange ett giltigt visningsnamn',
        validationErrorTitle: 'Valideringsfel',
      },
      tooltip: {
        electricityElhub: 'El',
        reactiveEnergy: 'Reaktiv energi',
        buildingsLabel: 'Byggnader',
        meteringPointsLabel: 'Mätpunkter',
        districtHeating: 'Fjärrvärme',
        solarPv: 'Producerad solenergi',
        exportedElectricity: 'Exporterad el',
      },
    },
    co2BarChart: {
      baseline: 'Referens',
      legendBaseline: 'Baseline',
      currentValues: 'Nuvarande värden',
      co2Emissions: 'CO₂-utsläpp',
      dailyEmissions: 'Dagliga utsläpp',
      monthlyEmissions: 'Månatliga utsläpp',
      months: [
        'Januari',
        'Februari',
        'Mars',
        'April',
        'Maj',
        'Juni',
        'Juli',
        'Augusti',
        'September',
        'Oktober',
        'November',
        'December',
      ],
      goal: 'Mål',
    },
    chartMenu: {
      rename: 'Byt namn',
      exportExcel: 'Exportera Excel',
      exportCSV: 'Exportera CSV',
    },
    periodOptions: {
      '3days': {
        label: 'Senaste 3 dagarna',
        mobileLabel: '3 dagar',
        chartLabel: '3 dagar',
      },
      '30days': {
        label: 'Senaste 30 dagarna',
        mobileLabel: '30 dagar',
        chartLabel: '30 dagar',
      },
      '3months': {
        label: 'Senaste 3 månaderna',
        mobileLabel: '3 månader',
        chartLabel: '3 månader',
      },
    },
    chartSubtitle: {
      today: 'Totalt för idag',
      oneDay: 'Totalt för 1 dag',
      days: 'Totalt för {days} dagar',
      oneWeek: 'Totalt för 1 vecka',
      weekAndDays: 'Totalt för 1 vecka och {days} dag(ar)',
      weeks: 'Totalt för {weeks} veckor',
      weeksAndDays: 'Totalt för {weeks} veckor och {days} dag(ar)',
      months: 'Totalt för {months} månader',
      monthsAndDays: 'Totalt för {months} månader och {days} dag(ar)',
      monthsAndWeeks: 'Totalt för {months} månader och {weeks} vecka/or',
    },
    datePicker: {
      startLabel: 'Start',
      endLabel: 'Slut',
    },
    weatherTemperature: {
      noData: 'Inga väderdata tillgängliga',
      headerTitle: 'Väderprognos',
      headerSubtitle: 'Prognos',
      tooltip: {
        conditions: 'Väderförhållanden',
        temperature: 'Temperatur',
        wind: 'Vind',
        windDirection: 'Vindriktning',
        pressure: 'Lufttryck',
        cloudCover: 'Molntäcke',
        fog: 'Dimma',
        uvIndex: 'UV-index',
        precipitation: 'Nederbörd nästa timme',
      },
      stats: {
        min: 'Min',
        avg: 'Snitt',
        max: 'Max',
        current: 'Nu',
      },
    },
    tempTrend: {
      stable: 'Stabil utomhustemperatur',
      graduallyRising: 'Gradvis stigande temperatur',
      graduallyFalling: 'Gradvis sjunkande temperatur',
      rising: 'Stigande utomhustemperatur',
      falling: 'Sjunkande utomhustemperatur',
    },
    noDataForPeriod: 'Inga energidata för vald period',
    totalEnergy: 'Total energi',
    filters: {
      noMatch: 'Inga noder matchar alla valda kategorier',
    },
    staleData: {
      warningText: 'gårdagens data är inte tillgänglig',
      showingDataFrom: 'Visar data från',
    },
    sankey: {
      noData: 'Ingen sankeydata tillgänglig.',
      searchNodes: 'Sök noder...',
      selectedNodes: 'Valda noder',
      csvValue: 'Värde (kWh)',
      csvDeviceId: 'Enhets ID',
    },
  },

  superSettings: {
    securityLog: {
      title: 'Säkerhetslogg',
      levelBadge: 'Nivå 10',
      intro:
        'Inloggningar, ändringar, dataåtkomst och API-användning för alla kunder. Inloggningar, ändringar och dataåtkomst sparas i 90 dagar, användning i 30 dagar.',
      error: 'Säkerhetsloggen kunde inte laddas.',
      tabs: {
        overview: 'Översikt',
        logins: 'Inloggningar',
        changes: 'Ändringar',
        reads: 'Dataåtkomst',
        usage: 'Användning',
        sessions: 'Sessioner',
      },
      filters: {
        period: 'Period',
        last24h: 'Senaste 24 timmarna',
        last7d: 'Senaste 7 dagarna',
        last30d: 'Senaste 30 dagarna',
        last90d: 'Senaste 90 dagarna',
        custom: 'Anpassad',
        vendor: 'Kund',
        allVendors: 'Alla kunder',
        exportCsv: 'Exportera CSV',
        refresh: 'Uppdatera',
      },
      totals: {
        logins: 'Inloggningar',
        loginsHint: '{users} användare, {ips} IP-adresser',
        reads: 'Dataåtkomst',
        readsHint: '{users} användare',
        readsTooltip:
          'Läsningar av användarlistor, kundlistor, leads och loggar',
        failedLogins: 'Misslyckade inloggningar',
        rateLimitedHint: '{count} stoppade av hastighetsgränsen',
        changes: 'Ändringar',
        deletesHint: '{count} raderingar',
        accessChanges: 'Behörighetsändringar',
        accessHint: 'Nivåer, kundåtkomst, Entra ID',
        requests: 'API-anrop',
        requestsHint: '{users} aktiva användare',
        compromised: 'Möjligen komprometterade',
        compromisedHint: 'Konton att kontrollera',
        unknownOutcome:
          '{count} inloggningar från innan utfall registrerades räknas separat.',
        truncated:
          'Perioden är stor; bara de första 20 000 posterna kontrollerades.',
      },
      attention: {
        title: 'Behöver uppmärksamhet',
        empty: 'Inget behöver uppmärksamhet under perioden.',
        high: 'Hög',
        medium: 'Medel',
        low: 'Låg',
        showMore: 'Visa alla {count}',
      },
      compromised: {
        title: 'Möjligen komprometterade konton',
        empty: 'Inget konto visar tecken på att vara komprometterat.',
        help: 'Användning som ingen människa kan stå för, eller en session som används från flera platser samtidigt.',
      },
      chart: {
        title: 'Inloggningar per dag',
        success: 'Lyckade',
        failed: 'Misslyckade',
        rateLimited: 'Hastighetsbegränsade',
      },
      sensitive: {
        title: 'Senaste behörighetsändringar',
        empty: 'Inga behörighetsändringar under perioden.',
      },
      alerts: {
        failedLoginsThenSuccess:
          '{count} misslyckade inloggningar för {who}, sedan en lyckad inloggning',
        failedLogins: '{count} misslyckade inloggningar för {who}',
        failedLoginsIp:
          '{count} misslyckade inloggningar från {ip}, mot {accounts} konton',
        rateLimited: '{count} stoppade inloggningsförsök för {who}',
        newIp: '{who} loggade in från en ny IP-adress ({ip})',
        levelRaised: '{who} höjdes från nivå {old} till {new} av {by}',
        accessChange: 'Behörighet ändrad för {who} ({fields}) av {by}',
        userDeleted: '{who} raderades av {by}',
        massDelete: '{who} raderade {count} poster inom 10 minuter',
        requestBurst: '{who} gjorde {count} anrop på en minut',
        alwaysOn: '{who} var aktiv {count} timmar under ett dygn',
        parallelLocations: '{who} användes från {count} IP-adresser samtidigt',
        parallelDevices: '{who} användes från {count} enheter samtidigt',
        robotRhythm:
          '{who} skickade anrop i maskinlikt jämn takt i {count} minuter',
        changeBurst: '{who} gjorde {count} ändringar inom 10 minuter',
        vendorHopping: '{who} arbetade i {count} kunder inom en timme',
        readBurst: '{who} läste kritisk data {count} gånger inom 10 minuter',
        unknown: 'Okänd varning',
        someone: 'okänt konto',
        occurrences: '{count} gånger under perioden',
      },
      alertNames: {
        failedLoginsThenSuccess: 'Inloggning efter många fel',
        failedLogins: 'Många misslyckade inloggningar',
        failedLoginsIp: 'IP med många fel',
        rateLimited: 'Hastighetsbegränsad',
        newIp: 'Ny IP-adress',
        levelRaised: 'Nivå höjd',
        accessChange: 'Behörighet ändrad',
        userDeleted: 'Användare raderad',
        massDelete: 'Massradering',
        requestBurst: 'Anropstopp',
        alwaysOn: 'Alltid på',
        parallelLocations: 'Flera platser samtidigt',
        parallelDevices: 'Flera enheter samtidigt',
        robotRhythm: 'Maskinlik takt',
        changeBurst: 'Ändringstopp',
        vendorHopping: 'Kundhopp',
        readBurst: 'Massläsning',
      },
      logins: {
        time: 'Tid',
        outcome: 'Utfall',
        method: 'Metod',
        account: 'Konto',
        vendor: 'Kund',
        ip: 'IP-adress',
        device: 'Enhet',
        allOutcomes: 'Alla utfall',
        allFailures: 'Alla fel',
        allMethods: 'Alla metoder',
        searchEmail: 'Sök e-post',
        searchIp: 'IP-adress',
        filterByIp: 'Visa inloggningar från denna IP',
        filterByAccount: 'Visa inloggningar för detta konto',
        empty: 'Inga inloggningar matchar filtren.',
      },
      outcomes: {
        success: 'Lyckad',
        wrong_password: 'Fel lösenord',
        unknown_user: 'Okänd användare',
        inactive: 'Inaktiverad',
        invalid_input: 'Ogiltig inmatning',
        rate_limited: 'Hastighetsbegränsad',
        unknown_vendor: 'Okänd tenant',
        invalid_session: 'Ogiltig session',
        unknown: 'Inte registrerat',
      },
      methods: {
        password: 'Lösenord',
        entra: 'Entra ID',
      },
      changes: {
        time: 'Tid',
        action: 'Åtgärd',
        collection: 'Samling',
        record: 'Post',
        by: 'Av',
        vendor: 'Kund',
        endpoint: 'Anrop',
        history: 'Historik',
        allActions: 'Alla åtgärder',
        create: 'Skapad',
        update: 'Uppdaterad',
        delete: 'Raderad',
        collectionPlaceholder: 'Samling, till exempel users',
        fieldPlaceholder: 'Fält, till exempel level',
        empty: 'Inga ändringar matchar filtren.',
        filterByUser: 'Visa ändringar gjorda av denna användare',
      },
      reads: {
        time: 'Tid',
        user: 'Användare',
        area: 'Vad',
        vendor: 'Kund',
        ip: 'IP-adress',
        device: 'Enhet',
        allAreas: 'Allt utom säkerhetsloggen',
        everything: 'Allt, även säkerhetsloggen',
        searchIp: 'IP-adress',
        filterByUser: 'Visa läsningar av denna användare',
        filterByIp: 'Visa läsningar från denna IP',
        empty: 'Inga läsningar matchar filtren.',
        note: 'Läsningar av användarlistor, kundlistor, leads och loggar, sparas i 90 dagar.',
      },
      readAreas: {
        vendors: 'Kundlista',
        users: 'Användarlista',
        alarmUsers: 'Larmanvändare',
        energyLabelLeads: 'Energimärkningsleads',
        enerskyAccess: 'Enersky-åtkomst',
        feedback: 'Feedback',
        requestLogs: 'Förfrågningsloggar',
        securityLog: 'Säkerhetslogg',
        other: 'Övrigt',
      },
      usage: {
        user: 'Användare',
        requests: 'Anrop',
        peak: 'Topp per minut',
        activeMinutes: 'Aktiva minuter',
        ips: 'IP-adresser',
        devices: 'Enheter',
        vendors: 'Kunder',
        flags: 'Flaggor',
        flaggedOnly: 'Bara användare med flaggor',
        compromisedBadge: 'Möjligen komprometterad',
        empty: 'Ingen API-användning under perioden.',
        note: 'API-användning sparas i 30 dagar.',
      },
      sessions: {
        user: 'Användare',
        rights: 'Behörigheter',
        method: 'Metod',
        ip: 'IP-adress',
        device: 'Enhet',
        started: 'Inloggad',
        lastSeen: 'Senast sedd',
        status: 'Status',
        open: 'Öppen',
        revoked: 'Avslutad',
        expired: 'Utgången',
        idle: 'Inaktiv',
        level: 'Nivå {level}',
        tenants: '+{count} kunder',
        openOnly: 'Bara öppna sessioner',
        revoke: 'Avsluta',
        revokeTitle: 'Avsluta denna session?',
        revokeText: 'Sessionen för {who} ({method}, {ip}) avslutas.',
        cancel: 'Avbryt',
        revokeFailed: 'Sessionen kunde inte avslutas.',
        empty: 'Inga sessioner matchar filtren.',
        note: 'En session slutar {absolute} timmar efter inloggning, eller efter {idle} timmar utan användning. Sessioner sparas i 90 dagar.',
        notEnforced:
          'Sessioner registreras men tillämpas inte ännu. Att avsluta en session markerar den som avslutad; användaren loggas ut när tillämpningen slås på.',
      },
      history: {
        title: 'Posthistorik',
        empty: 'Inga registrerade ändringar för denna post.',
        close: 'Stäng',
        open: 'Visa historiken för denna post',
      },
    },
    areasMenu: {
      securityLog: 'Säkerhetslogg',
      createDashboard: 'Skapa instrumentpanel',
      feedback: 'Feedback',
      projects: 'Projekt',
      icMeter: 'IC-mätare',
      lakeSensors: 'Sjösensorer',
      eosDevices: 'EOS-enheter',
      deviceMapping: 'Enhetskartläggning',
      energyLabeling: 'Energimärkning',
      alarmSystems: 'Larmsystem',
      enerskyAccess: 'Enersky-åtkomst',
    },
    dataQuality: {
      title: 'Datakvalitetsinspektör',
      subtitle:
        'Realtidsöversikt över alla sensorgrupper och enheternas datastatus.',
      noLakes: 'Inga sensorgrupper hittades',
      noDevices: 'Inga enheter',
      allReporting: 'Alla rapporterar',
      missing: 'saknas',
      device: 'enhet',
      devices: 'enheter',
      missingData: 'Saknade data',
    },
    createDashboard: {
      header: 'Ny kundpanel',
      sections: {
        companyDetails: 'Företags­uppgifter',
        address: 'Adress',
        contactDetails: 'Kontakt­uppgifter',
      },
      fields: {
        companyName: 'Företagsnamn',
        organizationNumber: 'Organisationsnummer',
        street: 'Gata',
        city: 'Stad',
        postcode: 'Postnummer',
        country: 'Land',
        email: 'E-post',
        phoneNumber: 'Telefonnummer',
        timezone: 'Kundens tidszon',
      },
      helperText: {
        organizationNumber: 'Företagets registreringsnummer',
        timezone: 'Välj kundens lokala tidszon',
      },
      buttons: {
        cancel: 'Avbryt',
        createClient: 'Skapa kund',
      },
    },
    sastechFeedback: {
      title: 'Sastech Feedback',
      table: {
        title: 'Feedbackmeddelanden',
        message: 'Meddelande',
        actions: 'Åtgärder',
        resolved: 'Löst',
        resolvedBy: 'av',
        unResolved: 'Olöst',
        filter: 'Filter',
        developerFeedback: 'Feedback från utvecklare',
        comment: 'Kommentar',
        assignDeveloper: 'Tilldela utvecklare',
        suggestedAction: 'Föreslagen åtgärd',
        tags: 'Taggar',
        noTagsProvided: 'Inga taggar angivna',
        vote: 'Rösta',
        resolvedTicketsThisWeek: 'Lösta feedback denna vecka',
        last7Days: 'Senaste 7 dagarna',
        newTicketsThisWeek: 'Ny feedback denna vecka',
        featureTicketsThisWeek: 'Funktionsfeedback denna vecka',
        bugTicketsThisWeek: 'Buggfeedback denna vecka',
        resolvedTickets: 'Lösta feedback',
      },
      buttons: {
        resolve: 'Lös',
        save: 'Spara svar',
      },
      confirm: {
        resolve: 'Är du säker på att du vill lösa denna feedback?',
        delete: 'Är du säker på att du vill ta bort denna feedback?',
      },
      details: {
        browserInfo: 'Webbläsarinfo:',
        device: 'Enhet',
        operatingSystem: 'Operativsystem',
        path: 'Sökväg',
        resolution: 'Upplösning',
        na: 'saknas',
        screenshotAlt: 'skärmdump',
      },
    },
    alarmSystems: {
      titleEdit: 'Redigera larm­system',
      accordion: {
        details: 'Larmdetaljer',
        heartbeat: 'Heartbeatdetaljer',
        notification: 'Meddelandedetaljer',
        connectedDevices: 'Anslutna enhetslarm',
      },
      fields: {
        systemName: 'Namn på larmsystem',
        description: 'Beskrivning',
        location: 'Plats',
        key: 'Nyckel',
      },
      heartbeat: {
        explanation:
          'Heartbeat-intervallen är tiden i sekunder mellan varje heartbeat-signal som alarmsystemet skickar till servern. Denna signal visar att systemet är aktivt och fungerar korrekt. Om servern inte tar emot en signal inom en viss tid kan det indikera ett problem med systemet.',
        monitor: 'Heartbeat-övervakning',
        hours: 'Timmar',
        minutes: 'Minuter',
        seconds: 'Sekunder',
      },
      notification: {
        type: 'Meddelandetyp',
        selectType: 'Välj meddelande­typ',
        options: {
          email: 'E-post',
          sms: 'SMS',
        },
        recipient: 'Meddelande­mottagare',
        recipients: 'Meddelande­mottagare',
        selectUser: 'Välj användare',
        orAddManually: 'Eller lägg till e-post eller mobilnummer manuellt:',
        addRecipient: 'Lägg till mottagare',
        contact: 'E-post / mobilnummer',
        minimumSeverity: 'Lägsta allvarlighetsgrad',
        severityLevels: {
          1: 'Info',
          2: 'Varning',
          3: 'Mindre',
          4: 'Allvarlig',
          5: 'Kritisk',
        },
        errors: {
          empty: 'Mottagaren får inte vara tom',
          duplicate: 'Denna mottagare finns redan',
          invalidEmail: 'Ogiltigt e-postformat',
          selectTypeFirst: 'Välj meddelande­typ först',
          enterEmail: 'Ange en e-postadress',
          enterMobile: 'Ange ett mobilnummer',
        },
      },
      connectedDevices: {
        empty: 'Inga enhetslarm är kopplade till detta larmsystem.',
        unnamed: 'Namnlöst larm',
      },
      titleCreate: 'Skapa larmsystem',
      confirmDelete: 'Är du säker på att du vill ta bort detta larmsystem?',
      list: {
        new: 'Ny',
        search: 'Sök...',
        empty: 'Inga larmsystem hittades',
      },
      updatedSuccess: 'Larmsystem uppdaterat',
      createdSuccess: 'Larmsystem skapat',
      deletedSuccess: 'Larmsystem borttaget',
      updateError: 'Fel vid uppdatering av larmsystem',
      createError: 'Fel vid skapande av larmsystem',
      deleteError: 'Fel vid borttagning av larmsystem',
      fetchError: 'Fel vid hämtning av larmsystem',
      fetchLogsError: 'Fel vid hämtning av larmloggar',
    },
    enerskyAccess: {
      list: {
        header: 'Enersky-åtkomstposter',
        description: 'Hantera datadelningsåtkomst och avtalsstatus för kunder',
        tableTitle: 'Åtkomstposter',
        addButton: 'Skapa post',
        emptyState: 'Inga poster hittades.',
        searchPlaceholder: 'Sök bland befintliga poster…',
        backButton: 'Tillbaka till poster',
      },

      columns: {
        vendor: 'Leverantör',
        customer: 'Kund',
        status: 'Status',
      },

      validation: {
        missingVendor: 'Leverantör är obligatorisk.',
        missingFirstName: 'Förnamn är obligatoriskt.',
        missingLastName: 'Efternamn är obligatoriskt.',
        missingEmail: 'En giltig e-postadress måste anges.',
        missingCompanyName: 'Företagsnamn är obligatoriskt för företagskunder.',
        missingOrganizationNumber: 'Organisationsnummer är obligatoriskt.',
        missingNationalId: 'Personnummer är obligatoriskt.',
      },

      feedback: {
        save: {
          missingInfoTitle: 'Saknad information',
          missingInfoMessage: 'Vänligen fyll i alla obligatoriska fält.',
          createSuccessTitle: 'Post skapad',
          createSuccessMessage: 'Post skapad och avtalsmejl skickat.',
          updateSuccessTitle: 'Uppdaterad',
          updateSuccessMessage: 'Kontaktuppgifterna uppdaterades.',
          errorTitle: 'Fel',
          errorMessage: 'Misslyckades att spara.',
          duplicateEndUser: 'Den här kunden finns redan i Enersky.',
        },

        refresh: {
          mpidsTitle: 'Abonnemang uppdaterade',
          mpidsMessage: 'MPID-status uppdaterade.',
          statusTitle: 'Status uppdaterad',
          statusMessage: 'Poststatus och MPID uppdaterade.',
          errorTitle: 'Fel',
          errorMessage: 'Misslyckades att uppdatera data.',
        },

        resend: {
          title: 'E-post skickad',
          message: 'Avtalsmejlet skickades igen till kunden.',
          errorTitle: 'Fel',
          errorMessage: 'Misslyckades att skicka avtalsmejlet igen.',
        },

        history: {
          title: 'Begäran om historiska data köad',
          message: 'Data har lagts i kö.',
          errorTitle: 'Fel',
          errorMessage: 'Misslyckades att lägga mätvärden i kö.',
        },

        delete: {
          successTitle: 'Post borttagen',
          successMessage: 'Enersky-åtkomstposten har tagits bort.',
          errorTitle: 'Fel',
          errorMessage: 'Misslyckades att ta bort posten.',
        },
      },

      editEnerskyAccess: {
        labels: {
          basicInfo: 'Grundläggande information',
          vendor: 'Leverantör',
          firstName: 'Förnamn',
          lastName: 'Efternamn',
          email: 'E-post',
          companyName: 'Företagsnamn',
          privatePerson: 'Privatperson',
          nationalId: 'Personnummer',
          organizationNumber: 'Organisationsnummer',
          systemInfo: 'Information om Enersky-åtkomstpost',
          accessUrl: 'Åtkomst-URL',
          requestId: 'Begärande-ID',
          errorMessage: 'Felmeddelande',
          mpidSection: 'Mätpunkter (MPID)',
          mpid: 'MPID',
          meterNumber: 'Mätarnummer',
          address: 'Adress',
          description: 'Beskrivning',
          priceArea: 'Prisområde',
          status: 'Status',
          actions: 'Åtgärder',
          deleteConfirmMessage:
            'Är du säker på att du vill ta bort denna post?',
        },

        buttons: {
          resendLink: 'Skicka länken igen',
          refreshSubscriptions: 'Uppdatera abonnemang',
          readHistoricalData: 'Hämta historiska data',
        },

        status: {
          unknown: 'Okänd status',
        },
        none: 'Ingen',
        unknownError: 'Okänt fel',
      },
      status: {
        Pending: 'Väntar',
        'Contract email sent': 'Avtalsmejl skickat',
        'Contract link requested': 'Avtalslänk begärd',
        Completed: 'Slutförd',
        Error: 'Fel',
        Unknown: 'Okänd status',
      },
    },

    chirpStackKeys: {
      title: 'Importerade nyckelfiler',
      addButton: 'Importera nycklar',
      columns: {
        fileName: 'Filnamn',
        uploadedAt: 'Uppladdad',
        importedCount: 'Importerade antal',
      },
      importFile: 'Importera ChirpStack-nyckelfil',
      preview: {
        title: 'Förhandsgranskning',
        noRows: 'Inga förhandsrader.',
        close: 'Stäng',
        cancel: 'Avbryt',
        confirm: 'Bekräfta import',
      },
      feedback: {
        loadError: 'Misslyckades med att ladda filer',
        previewError: 'Förhandsgranskning misslyckades',
        invalidExcel: 'Ogiltig Excel-fil.',
        missingFile: 'Originalfil saknas, välj igen',
        importSuccess: 'Importen lyckades',
        importError: 'Importen misslyckades',
      },
    },

    icMeterData: 'IC-mätardata',
    buildingSensorData: 'Byggsensordata',
    eosSensorData: 'EOS-sensordata',
    protocol: 'Kommunikationsprotokoll',
  },
  buildings: {
    sidebar: {
      modifyToggle: 'Ändra',
      editBuildingTitle: 'Redigera byggnad',
      buildingOverviewTitle: 'Byggnadsöversikt',
      editZoneTitle: 'Redigera zon',
      outdoorTemperatureTitle: 'Utomhustemperatur',
      indoorClimateTitle: 'Inomhusklimat',
      buildingTemperature: 'Byggnadens temperatur',
      floorTemperature: 'Våningens temperatur',
      outdoorTempLabel: 'Utetemp.:',
      electricityPriceLabel: 'Elpris:',
      energyLabel: 'Energimärkning:',
      noData: 'Inga data',
      aspaTitle: 'Aspa inställning',
      zoneFloors: {
        selectFloorLabel: 'Välj zonvåning:',
        selectBuildingFloorLabel: 'Välj byggnadsvåning:',
        changeFloor: '- Byt våning -',
        addFloor: 'Lägg till våning',
        groundFloor: 'Bottenvåning',
      },
    },
    aspa: {
      title: 'ASPA-inställningar',
      noPayload: 'Ingen ASPA-data hittades för denna byggnad.',
      avgTemp: 'Medeltemperatur',
      acrossAllZones: 'Över alla zoner',
      highestZoneTemp: 'Högsta zontemp.',
      peakZoneReading: 'Högsta zonavläsning',
      lastUpdated: 'Senast uppdaterad',
      payloadsReceived: 'datapaket mottagna',
      setpointOverview: 'Börvärdesöversikt',
      hourView: '24-timmarsvy',
      hourOfDay: 'Timme på dygnet',
      dailySetpoint: 'Dagligt börvärde (°C)',
      liveSetpoint: 'Aktuellt börvärde (°C)',
      avg: 'Medel',
      peak: 'Topp',
      trends: 'Trender',
      temperature: 'Temperatur',
      humidity: 'Fuktighet',
      noTrendData: 'Ingen trenddata.',
      recommendations: 'Rekommendationer',
      noRecommendations: 'Inga rekommendationer hittades.',
      actionKeys: {
        cool: 'Kylning',
        coolingLevel: 'Kylnivå',
        preCool: 'Förkylning',
        heat: 'Uppvärmning',
        heatingLevel: 'Värmenivå',
        preHeat: 'Förvärmning',
      },
      items: 'objekt',
      on: 'På',
      off: 'Av',
      samples: 'mätningar',
      trendPeriod: 'Senaste 2 timmarna',
    },
    details: {
      header: 'Byggnadsdetaljer',
      form: {
        buildingName: 'Byggnadsnamn',
        active: 'Aktiv',
        buildingInformation: 'Byggnadsinformation',
        buildingType: 'Byggnadstyp (NS-standard)',
        buildingCategory: 'Byggnadskategori',
        constructionYear: 'Byggnadsår',
        numberOfFloors: 'Antal våningar',
        netUsableFloorArea: 'Nettoanvändbar golvarea (m²)',
        gridRegion: 'Nätområde',
        selectGridRegion: '- Välj område -',
        mix: 'CO₂-mix',
        addressAndGps: 'Adress & GPS',
        street: 'Gata',
        street2: 'Gata 2',
        postCode: 'Postnummer',
        city: 'Stad',
        country: 'Land',
        latitude: 'Latitud',
        longitude: 'Longitud',
        fetchGps: 'Hämta GPS',
        fillStreetCityError:
          'Fyll i både gata och stad för att hämta GPS-koordinater.',
        requiredAddressFields: '{fields} måste fyllas i innan du sparar.',
        searchCountry: 'Sök land',
        floorNumber: 'Våningsnummer',
        preferredCurrency: 'Föredragen valuta',
        climateGoalPercentage: 'Procentandel av klimamål',
        changeModel: 'Byt byggnadsmodell',
        defaultStartingFloor: 'Startvåning',
        startingViewHint:
          'Rotera, panorera och zooma förhandsvisningen för att välja vyn som byggnaden öppnas med.',
        matrikkelData: {
          title: 'Matrikkeldata',
          error: 'Det gick inte att hämta matrikkeldata',
          errorTitle: 'Fel',
          matrikkelId: 'Matrikkel-ID',
          cadastralNumber: 'Gårdsnummer',
          propertyUnitNumber: 'Bruksnummer',
          sectionNumber: 'Sektionsnummer',
          unitNumber: 'Enheter',
          leaseholdNumber: 'Festenummer',
          municipalityName: 'Kommunnamn',
          municipalityNumber: 'Kommunnummer',
          success: 'Lyckades',
          successTitle: 'Matrikkeldata hämtad',
          fetchMatrikkelData: 'Hämta matrikkeldata',
          buildingNumber: 'Byggnadsnummer',
          errorMissing: 'Saknade obligatoriska adressfält',
          errorTooMany: 'För många adresser hittades',
          errorNotFound: 'Ingen adress hittades',
          unitId: 'Enhets-ID',
          noUnitIdFound:
            'Ingen enhet hittades på denna adress. Vänligen kontrollera adressen mot seeiedom.no och försök igen.',
          sectionTitle: 'Bruksenhet',
          sectionsTitle: 'Sektion',
          fetchedFromMatrikkel: 'Hämtad från matrikkel',
          overrideButton: 'Åsidosätt bruksenhet',
          overrideSectionButton: 'Åsidosätt sektion',
          addButton: 'Lägg till bruksenhet',
          addSectionButton: 'Lägg till sektion',
          manualWarning:
            'Endast nödvändigt om matrikkeldata saknas eller är felaktiga.',
          buildingType: 'Byggnadstyp',
        },
      },
      baseline: {
        title: 'Baslinje',
        recalcButton: 'Beräkna om baslinje',
        confirmRecalculate: 'Är du säker på att du vill beräkna om baslinjen?',
        success: 'Baslinje beräknad',
        error: 'Kunde inte beräkna baslinje',
        subscriptions: {
          title: 'Elhub-prenumerationer',
          loading: 'Läser in prenumerationer…',
          emptyState: 'Inga prenumerationer hittades. Lägg till nedan.',
          actions: {
            unsubscribe: 'Avsluta',
            subscribe: 'Prenumerera',
            delete: 'Ta bort',
            addPlaceholder: 'Ange mätpunkts-ID',
            status: {
              waitingApproval: 'Väntar på kundens godkännande i Elhub',
            },
            validation: {
              onlyDigits: 'ID får endast innehålla siffror',
              exactLength:
                'ID måste vara exakt 18 siffror (t.ex. 707057500042153290)',
              startsWith: 'ID måste börja med 7070575000',
              unique: 'ID måste vara unikt',
            },
            move: {
              selectTargetBuilding: '- Välj målbyggnad -',
              moveSelected: 'Flytta markerade',
              instructions:
                'Markera prenumerationer med kryssrutor (kan ta upp till 1 min per prenumeration).',
              moveSubscriptions: 'Flytta prenumerationer',
            },
            feedback: {
              subscribeSuccess: 'Prenumerationsförfrågan skickad',
              unsubscribeSuccess: 'Avslutad prenumeration',
              deleteSuccess: 'Prenumeration borttagen',
              subscribeError: 'Misslyckades att prenumerera',
              unsubscribeError: 'Misslyckades att avsluta',
              deleteError: 'Misslyckades att ta bort',
            },
          },
        },
      },
      report: { title: 'Rapport' },
    },
    model3d: {
      title: '3D-modell',
    },
    zoneEdit: {
      title: 'Zoninställningar',
      form: {
        zoneName: 'Zonnamn',
        floorNumber: 'Våning',
        selectCategory: 'Välj kategori',
        isHeated: 'Uppvärmd zon',
        displayHint: 'Så visas zonen i 3D-vyn.',
        cardSize: 'Kortstorlek',
        zoneColor: 'Zonfärg',
        devices: {
          availableDevices: 'Tillgängliga enheter',
          zoneDevices: 'Zonens enheter',
          noMatches: 'Inga enheter matchar sökningen',
        },
        deleteButton: 'Ta bort zon',
        deleteZoneDescription: 'Tar bort zonen permanent.',
        deleteZoneConfirm: 'Är du säker på att du vill ta bort zonen?',
        deleteError: 'Det gick inte att ta bort zonen',
      },
    },
    technicalRoom: {
      titles: 'Tekniska rum',
      emptyState: 'Inga tekniska rum hittades.',
      technicalRoomDescription: 'Beskrivning av det tekniska rummet',
      technicalRoomNamePlaceholder: 'Namn på tekniskt rum',
      technicalRoomDevices: 'Enheter i tekniskt rum',
      addDevice: 'Lägg till enhet',
      technicalRoomDevice: 'Tekniskt rum enhet',
      removeDevice: 'Ta bort',
      searchPlaceholder: 'Sök tekniskt rum',
      technicalRoomOverview: 'Översikt tekniskt rum',

      technicalRoomValue: 'Värde',
      technicalRoomSeen: 'Senast sedd',
      addTechnicalRoom: 'Lägg till tekniskt rum',
      addDeviceButton: 'Lägg till enhet',
      removeDeviceButton: 'Ta bort enhet',
      deviceType: 'Enhetstyp',
      editorTitle: 'Tekniska rum',
      selectRoom: 'Välj tekniskt rum',
      threeDModel: '3D-modell',
      replace: 'Byt',
      selectModel: 'Välj en 3D-modell',
      modelDefaultsGroup: 'Standardmodeller',
      noModel: 'Ingen 3D-modell kopplad till detta rum.',
      bind: 'Koppla',
      rebind: 'Koppla om',
      unbind: 'Koppla från',
      boundTo: 'Kopplad till',
      notBound: 'Ej kopplad',
      hide: 'Dölj i 3D',
      show: 'Visa i 3D',
      size: 'Storlek',
      remove: 'Ta bort från rum',
      pickingHint: 'Klicka på modellen för att koppla',
      pickingCardHint:
        'Klicka på en del av modellen, eller på bakgrunden för att placera kortet fritt',
      searchDevices: 'Sök enheter…',
      noDevicesAvailable: 'Inga enheter tillgängliga',
      noMatches: 'Inga träffar',
      unnamedDevice: 'Namnlös enhet',
      couldNotAddDevice: 'Det gick inte att lägga till enheten',
      noReadings24h: 'Inga avläsningar de senaste 24 timmarna',
      dragToReposition: 'Dra för att flytta',
      hideGraph: 'Dölj graf',
      showGraph: 'Visa graf',
      lockedHint: 'Lås upp vyn för att flytta enheter',
      clickToEdit: 'Klicka för att redigera',
      noDescription: 'Ingen beskrivning',
      noTitle: 'Ingen titel',
      showCardTitle: 'Korttitel',
      showDeviceName: 'Enhetsnamn',
      cardVisualization: 'Kortvisualisering',
      modelAnimation: 'Modellanimation',
      showLine: 'Kopplingslinje',
      lineColor: 'Linjefärg',
      resetColor: 'Återställ färg',
      darkTheme: 'Mörkt tema',
      showUnit: 'Måttenhet',
      trendLine: 'Trendlinje',
      trendBars: 'Trendstaplar',
      showUpdated: 'Senast uppdaterad',
      visualizationRules: 'Visualiseringsregler',
      ruleDataKey: 'Datanyckel',
      ruleValue: 'Värde',
      triggers: 'Utlösare',
      addTrigger: 'Lägg till utlösare',
      ruleOff: 'Av',
      ruleSlow: 'Långsam',
      ruleFast: 'Snabb',
      ruleNoEffect: 'Ingen effekt',
      ruleNoColor: 'Ingen färg',
      ruleReverse: 'Vänd riktning',
      particleFlow: 'Partikelflöde',
      drawFlow: 'Rita flöde',
      flowHint: 'Klicka på modellen för att lägga till punkter.',
      flowFollowsHint:
        'Partiklarna följer utlösarna i modellanimationen. När animationen är av stannar partiklarna.',
      flowColorHint:
        'Klicka på en punkt på flödet i modellen för att byta färg därifrån.',
      flowColorFromPoint: 'Färg från vald punkt',
      flowFollows: 'Följer animationen',
      particles: 'Partiklar',
      ruleDataKeyRequired: 'Välj en datanyckel för visualiseringsregeln',
      newTechnicalRoom: 'Nytt tekniskt rum',
      roomNamePlaceholder: 't.ex. Ventilation, Pannrum, Värmepump',
      selectBuilding: 'Välj en byggnad',
      nameRequired: 'Namn krävs',
      buildingRequired: 'Byggnad krävs',
      couldNotCreateRoom: 'Det gick inte att skapa rummet',
      creating: 'Skapar',
      loadError: 'Det gick inte att läsa in tekniskt rum',
      textPlaceholder: 'Skriv text…',
      noText: 'Ingen text',
      linkToRoom: 'Gå till rum',
      noLink: 'Ingen länk',
      linkHint:
        'I låst vy öppnar ett klick på modellen eller kortet detta rum.',
      confirmRemoveAnnotation:
        'Är du säker på att du vill ta bort denna text från rummet?',
      dragToReorder: 'Dra för att ändra ordning',
      drawFrame: 'Rita ram',
      redrawFrame: 'Rita ram på nytt',
      frameDrawHint: 'Klicka på två hörn i ritningen',
      noFrame: 'Ingen ram ritad',
      frameDrawn: 'Ram ritad',
      confirmRemoveFrame:
        'Är du säker på att du vill ta bort denna ram från rummet?',
      confirmRemoveLink:
        'Är du säker på att du vill ta bort denna länk från rummet?',
      annotationsTab: 'Länkar och text',
      noAnnotations: 'Inga länkar eller text i detta rum.',
      placeText: 'Placera',
      replaceText: 'Placera på nytt',
      placed: 'Placerad',
      placeTextHint: 'Klicka på ritningen där texten ska stå',
      placeInfoHint: 'Klicka på ritningen där bubblan ska stå',
      confirmRemoveInfo:
        'Är du säker på att du vill ta bort denna infobubbla från rummet?',
      ruleAngle: 'Vinkel (grader)',
      infoPanel: 'Larm och driftkalender',
      alarmsTab: 'Larm',
      calendarsTab: 'Driftkalender',
      noAlarmSystems: 'Inga larmsystem är kopplade till detta rum.',
      noCalendars: 'Inga driftkalendrar är kopplade till detta rum.',
      systemAlarm: 'Systemlarm',
      openInSettings: 'Öppna i inställningar',
      confirmRemoveDevice:
        'Är du säker på att du vill ta bort denna enhet från rummet?',
      attributes: 'Attribut',
      selectAttribute: 'Välj ett attribut',
      mappedGroup: 'Mappade attribut',
      payloadGroup: 'Rådata',
      mappedNoneText: 'Inga tillgängliga,',
      assignHere: 'tilldela här',
      confirmDeleteRoom: 'Är du säker på att du vill ta bort {name}?',
      roomDeleted: 'Tekniskt rum borttaget',
      renameRoom: 'Byt namn på tekniskt rum',
      noTechnicalRoomsForType: 'Inga tekniska rum av denna typ hittades',
      noDevices: 'Inga enheter i detta tekniska rum.',
      technicalRoomTypeLabel: 'Typ av tekniskt rum',
      technicalRoomTypes: {
        type: 'Välj typ',
        hvac: 'HVAC',
        technical: 'Tekniskt rum',
        electrical: 'Elektrisk',
        plumbing: 'VVS',
        other: 'Annat',
      },
      message: {
        success: 'Tekniskt rum skapades framgångsrikt',
        updateSuccess: 'Tekniskt rum uppdaterades framgångsrikt',
        deleteSuccess: 'Tekniskt rum raderades framgångsrikt',
        error: 'Ett fel uppstod vid bearbetning av din begäran',
        deleteConfirm: 'Är du säker på att du vill ta bort detta tekniska rum?',
      },
    },
  },
  threeD: {
    lockView: 'Lås vy',
    unlockView: 'Lås upp vy',
  },

  buildings3D: {
    header: {
      buildingTab: 'Byggnad',
      technicalTab: 'Teknisk',
    },
    footer: {
      home: 'Hem',
      measure: 'Mät',
      stopMeasure: 'Stoppa mätning',
      explode: 'Explodera',
      screenshot: 'Skärmbild',
      lock: 'Lås',
      unlock: 'Lås upp',
    },
    climate: {
      buildingClimate: 'Inomhusklimat',
      levelsTitle: 'Sektioner',
      startLabel: 'Start',
      endLabel: 'Slut',
      apply: 'Tillämpa',
      avgTemperature: 'Genomsnittlig temperatur',
      avgHumidity: 'Genomsnittlig luftfuktighet',
      avgCo2: 'Genomsnittlig CO₂',
      floor: 'Våning',
      wholeBuilding: 'Hela byggnaden',
      noTrendData: 'Ingen data',
      fetchData: 'Hämta data',
      startMustBeBeforeEnd: 'Start måste vara före slut.',
      groundFloor: 'Bottenvåning',
      weekdaysShort: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
    },
    status: {
      good: 'Normal',
      tooLow: 'För låg',
      tooHigh: 'För hög',
      warning: 'Varning',
      poor: 'Dålig',
    },
    warnings: {
      title: 'Varningar',
      highCo2: 'Högt CO₂',
      highTemp: 'Hög temperatur',
      lowTemp: 'Låg temperatur',
    },
    alarmLog: {
      title: 'Larmlogg',
      last24h: 'Senaste 24 timmarna',
      last7d: 'Senaste 7 dagarna',
      last30d: 'Senaste 30 dagarna',
      custom: 'Anpassad',
      zone: 'Zon',
      activeNow: 'Aktiva nu',
      today: 'Idag',
      yesterday: 'Igår',
      earlier: 'Tidigare',
      empty: 'Inga larm i detta intervall',
      loadError: 'Kunde inte ladda larmloggen.',
      unknownZone: 'Okänd zon',
    },
    deviceLayer: {
      moveDevices: 'Flytta modeller',
      moveHint: 'Dra för att flytta · ⇧ rotera · ⌘ höjd',
      moveThisDevice: 'Flytta den här enheten',
      doneMoving: 'Klar med flytten',
      changeModel: 'Byt modell',
      showDataBox: 'Visa datarutan',
      hideDataBox: 'Dölj datarutan',
      modelSize: 'Modellstorlek',
      dataSize: 'Datastorlek',
      hideZones: 'Dölj zoner',
      showZones: 'Visa zoner',
      hideModels: 'Dölj modeller',
      showModels: 'Visa modeller',
      hideModel: 'Dölj modellen',
      showModel: 'Visa modellen',
      suggested: 'Föreslagen',
      noModelsInCategory: 'Inga modeller i den här kategorin ännu',
      controllers: 'Styrenheter',
      models: {
        radiatorGlb: 'Radiator',
        panelOvenGlb: 'Panelelement',
        heatpumpGlb: 'Värmepump',
        indoorClimateGlb: 'Inomhusklimat',
        icmSensorGlb: 'ICM sensor',
        climateHubGlb: 'Klimathubb',
        ventilationOutletGlb: 'Ventilationsdon',
        ventilationGrillGlb: 'Ventilationsgaller',
      },
    },
    zoneControls: {
      leaveFloor: 'Lämna',
      drawZone: 'Dubbelklicka för att avsluta',
      clearZones: 'Rensa zoner',
      clickFloorToIsolate: 'Klicka på våning för att isolera',
      select: 'Välj',
      rectangle: 'Rektangel',
      circle: 'Cirkel',
      polygon: 'Polygon',
      zoneNameLabel: 'Zonnamn',
      heightLabel: 'Höjd',
      editVertexHint:
        'Dra i punkterna för att ändra, dubbelklicka för att lägga till fler',
      unnamedZone: 'Namnlös zon',
      zoneNameRequired: 'Zonnamn krävs',
      zonesMissingData: 'Zoner saknar 3D data',
      zonesMissingDataTitle: 'Zoner saknar 3D modelldata:',
      floorLabel: 'Våning',
      zoneCreated: 'Zon skapad',
      zoneUpdated: 'Zon uppdaterad',
      zoneDeleted: 'Zon raderad',
      failedToCreateZone: 'Kunde inte skapa zon',
      failedToUpdateZone: 'Kunde inte uppdatera zon',
      failedToDeleteZone: 'Kunde inte radera zon',
      confirmDeleteZoneTitle: 'Radera zon?',
      confirmDeleteZoneMessage:
        'Är du säker på att du vill radera denna zon? Detta kan inte ångras.',
    },
  },

  deviceAlarms: {
    updatedSuccess: 'Enhetslarm uppdaterat',
    createdSuccess: 'Enhetslarm skapat',
    deletedSuccess: 'Enhetslarm borttaget',

    editTitle: 'Redigera enhetslarm',
    createTitle: 'Skapa enhetslarm',
    title: 'Enhetslarm',
    manageAlarmsForDevice: 'Administrera larm för {device}',
    recipients: 'Mottagare',

    alarmDetails: 'Larmdetaljer',
    deviceSelection: 'Enhetsval',
    alarmConditions: 'Larmvillkor',
    condition: 'Villkor',
    conditions: 'Villkor',
    noConditions: 'Inga villkor har lagts till ännu.',
    noConditionsSaveError: 'Minst ett villkor krävs',

    name: 'Namn',
    description: 'Beskrivning',
    alarmSystem: 'Larmsystem',
    selectDevice: 'Välj enhet',
    dataKey: 'Datanyckel',
    selectKey: 'Välj nyckel',
    level: 'Nivå',
    operator: 'Operator',
    value: 'Värde',
    duration: 'Varaktighet (min)',
    message: 'Meddelande',
    active: 'Aktiv',

    greaterThan: 'Större än',
    lessThan: 'Mindre än',
    equal: 'Lika med',
    notEqual: 'Inte lika med',
    missing: 'Saknas',
    unchanged: 'Oförändrad',

    addTrigger: 'Lägg till utlösare',
    addCondition: 'Lägg till villkor',
    triggers: 'Utlösare',

    standardDevices: 'Standardenheter',
    eosDevices: 'EOS-enheter',
    noDataKeys: 'Inga datanycklar tillgängliga för denna enhet.',

    noAlarmSystems: 'Inga larmsystem tillgängliga.',
    pleaseCreateFirst: 'Vänligen skapa ett först',
    selectDeviceFirst: 'Välj en enhet först för att konfigurera larmvillkor.',
    messagePlaceholder: 'Varningsmeddelande att visa...',
    confirmDelete: 'Är du säker på att du vill ta bort detta enhetslarm?',
    list: {
      new: 'Ny',
      search: 'Sök...',
      empty: 'Inga enhetslarm hittades',
    },
    deleteAlarmTitle: 'Ta bort larm',
    deleteAlarmDescription: 'Den här åtgärden kan inte ångras.',
  },

  settings: {
    /* ----------------------------- NAV AREAS ---------------------------- */
    areas: {
      home: 'Hem',
      vendor: 'Allmänt',
      devices: 'Enheter',
      eos_devices: 'EOS-enheter',
      categories: 'Kategorier',
      users: 'Användare',
      themes: 'Teman',
      integrationOverview: 'API-integrationer',
      fileCloud: 'Fil-moln',
      energyPrices: 'Energipriser',
      alarms: 'Larm',
      alarmSystemDescription:
        'Hantera och anpassa larmsystem med skräddarsydda aviseringar och övervakning av hjärtfrekvens för att hålla dig informerad om kritiska händelser och säkerställa snabba åtgärder.',
      baseline: 'Baslinje',
      technicalRoomOverview: 'Tekniska rum',
      aspaSetup: 'ASPA inställningar',
      controlStrategy: 'Styrstrategi',
      operatingCalendar: 'Driftkalendrar',
      setpoint: 'Börvärden',
    },

    /* ------------------------------ HOME CARD --------------------------- */
    home: {
      title: 'Företags­instrumentpanel',
      tagline:
        'Hantera företagets inställningar, användare, enheter och teman på ett ställe',
    },

    /* --------------------------- DASHBOARD ITEMS ------------------------ */
    dashboardItems: {
      themes: {
        title: 'Teman',
        description: 'Skapa och hantera färgteman för din applikation',
        linkText: 'Visa teman',
      },
      users: {
        title: 'Användare',
        description: 'Hantera användarkonton och behörigheter',
        linkText: 'Visa användare',
      },
      eosDevices: {
        title: 'EOS-enheter',
        description: 'Övervaka och hantera energimätarsensorer',
        linkText: 'Visa EOS-enheter',
      },
      settings: {
        title: 'Inställningar',
        description: 'Konfigurera applikationens globala inställningar',
        linkText: 'Visa inställningar',
      },
      devices: {
        title: 'Enheter',
        description: 'Konfigurera och övervaka anslutna enheter',
        linkText: 'Visa enheter',
      },
      fileCloud: {
        title: 'Fil-moln',
        description:
          'Lagra, organisera och dela filer säkert inom organisationen',
        linkText: 'Visa filer',
      },
      integration: {
        title: 'API-integrationer',
        description: 'Konfigurera och hantera API-kopplingar och integrationer',
        linkText: 'Visa integrationer',
      },
      categories: {
        title: 'Kategorier',
        description: 'Skapa och hantera enhetskategorier',
        linkText: 'Visa kategorier',
      },
    },
    aspaSetup: {
      list: {
        header: 'ASPA inställningar',
        addButton: 'Lägg till ASPA inställning',
        emptyState: 'Inga ASPA inställningar hittades.',
        searchPlaceholder: 'Sök...',
      },
      edit: {
        name: 'ASPA inställningsnamn',
        units: 'Enheter',
        addUnit: 'Lägg till enhet',
        unitName: 'Enhetsnamn',
        setpoints: 'Börvärden',
        zones: 'Zoner',
        removeUnit: 'Ta bort enhet',
        copyMondayToWeekdays: 'Kopiera måndag till vardagar',
        copyMondayToAllDays: 'Kopiera måndag till alla dagar',
      },
      feedback: {
        deleteSuccess: 'ASPA inställning har tagits bort',
        deleteError: 'Ett fel uppstod vid borttagning av ASPA inställning',
        updateSuccess: 'ASPA inställning har uppdaterats',
        updateError: 'Ett fel uppstod vid uppdatering av ASPA inställning',
        createSuccess: 'ASPA inställning har skapats',
        createError: 'Ett fel uppstod vid skapande av ASPA inställning',
        saveError: 'Ett fel uppstod vid sparande av ASPA inställning',
      },
    },

    energyPrices: {
      list: {
        add: 'Lägg till energipris',
        header: 'Inställningar för energipriser',
        emptyState: 'Inga energiprisinställningar hittades.',
        searchPlaceholder: 'Sök energiprisinställningar...',
      },

      name: 'Namn',
      notes: 'Anteckningar',
      building: 'Byggnad',
      selectBuilding: 'Välj byggnad',
      validFrom: 'Giltig från',
      validTo: 'Giltig till',
      ongoing: 'Löpande',
      notSpecified: 'Ej angivet',

      electricityDetails: 'El-detaljer',
      priceModel: 'Prismodell',
      fixed: 'Fast pris',
      spotMarkup: 'Spot + påslag',
      fixedPricePerKWh: 'Fast pris per kWh',
      spotMarkupPerKWh: 'Påslag per kWh',

      supplierMonthlyFee: 'Leverantörens månadsavgift',
      co2Emissions: 'CO₂-utsläpp (gCO₂/kWh)',

      gridTariffs: 'Nätavgifter',
      gridTariff: 'Nätavgift',
      fixedMonthly: 'Fast månadsavgift',
      energyPerKWh: 'Energi per kWh',
      demandPerKWMonthly: 'Effektavgift per kW per månad',
      consumptionTaxPerKWh: 'Förbrukningsskatt per kWh',

      energySources: 'Energikällor',
      addEnergySources: 'Lägg till energikällor',
      energySource: 'Information om energikälla',
      sourceName: 'Källnamn',
      electricity: 'Levererad el',
      electricityPrice: 'Elpris',
      electricityProduced: 'Producerad el',
      electricityExported: 'Exporterad el',

      districtHeating: 'Fjärrvärme',
      districtHeatingSource: 'Fjärrvärmens energikälla',
      districtHeatingPrice: 'Fjärrvärmepris',
      districtHeatingEnergyPrice: 'Energipris (kr/kWh)',
      districtHeatingDemandPerKWMonthly: 'Högsta uppmätta effekt (kr/kW/månad)',
      fuelSources: 'Bränslekällor',
      fuelSource: 'Information om bränslekälla',
      fuelType: 'Energikälla',

      propane: 'Propan',
      fuelOilDiesel: 'Eldningsolja / Diesel',
      lng: 'Naturgas (LNG)',
      kerosene: 'Fotogen',
      pelletsBricks: 'Pellets / Briketter',
      biodiesel: 'Biodiesel',
      biogas: 'Biogas',
      other: 'Annat',

      consumptionUnit: 'Förbrukningsenhet',
      kg: 'kg',
      liter: 'liter',
      unitPrice: 'Enhetspris',
      consumption: 'Förbrukning',
      conversionFactorToKWh: 'Omräkningsfaktor till kWh',

      periodLabel: 'Period',
      periodLabelPlural: 'Perioder',
      periodName: 'Periodnamn',
      addPeriod: 'Lägg till period',
      removePeriod: 'Ta bort period',
      removePeriodConfirmation:
        'Är du säker på att du vill ta bort denna period?',
      noPeriodsDefined: 'Inga perioder.',
      overlappingPeriodsError:
        'Perioderna "{p1}" och "{p2}" överlappar.\n\n' +
        'Du kan inte ha två perioder som gäller samtidigt (samma månader och överlappande tider). ' +
        'Justera månader eller aktiva tider innan du sparar.',
      confirmRemovePeriod: 'Är du säker på att du vill ta bort perioden?',
      mixedMonthsError:
        'Du kan inte blanda specifika månader med "alla månader" (tomma månader) mellan perioder.\n\n' +
        'Dessa perioder måste välja månader: {periods}\n\n' +
        'Tips: Välj månader för alla perioder, eller lämna månader tomma för alla perioder.',

      generalInformation: 'Allmän information',
      activeMonths: 'Aktiva månader (tomt = alla)',
      activeBetween: 'Aktiv tid (tomt = hela dygnet)',
      chosenMonths: 'Aktiva månader',
      activeHours: 'Aktiva tider',
      allYear: 'Hela året',
      allDay: 'Hela dygnet',
      addAdditionalTimer: 'Lägg till ytterligare tidsintervall',
      startTime: 'Starttid ',
      endTime: 'Sluttid ',
      timeRangeInvalid: 'Sluttiden måste vara efter starttiden',
      timeRangesOverlap: 'Perioder får inte överlappa',
      timeRangeEqual: 'Start- och sluttid kan inte vara samma',

      /* Fjärrvärme CO₂ */
      co2Source: 'Fjärrvärmens energityp',
      co2Array: [
        'Elektricitet',
        'Avfall',
        'Lätt eldningsolja',
        'Tung eldningsolja',
        'Gasol',
        'Naturgas (LNG)',
        'Primärt träbiobränsle',
        'Sekundärt träbiobränsle',
        'RT-flis',
        'Pellets, briketter och pulver',
        'Bioolja',
        'Värmepump',
      ],

      fixedFees: 'Fasta avgifter',
      substationFee: 'Undercentralavgift (per månad)',
      reactiveEffect: 'Avgift för reaktiv effekt',
      connectedDevices: 'Anslutna enheter',
      noConnectedDevices: 'Inga anslutna enheter',
      deletedDevice: 'Borttagen',
      removeSource: 'Ta bort källa',
      noLinkedDevices: 'Inga kopplade enheter',
      linked: 'Kopplade enheter',
      unlinkDeviceMessage: 'Är du säker på att du vill ta bort denna enhet?',
      linkSourceTitle: 'Koppla källa till EOS-enhet',
      linkSource: 'Koppla källa till EOS-enheter',
      linkSourceDescription:
        'Välj vilka EOS-enheter som är kopplade till denna energikälla.',
      removeElectricitySourceConfirmation:
        'Är du säker på att du vill ta bort elkällan ',
      removeDistrictHeatingSourceConfirmation:
        'Är du säker på att du vill ta bort fjärrvärmekällan ',
      removeFuelSourceConfirmation:
        'Är du säker på att du vill ta bort bränslekällan ',
    },

    setpoint: {
      title: 'Börvärden',
      backToList: 'Alla börvärden',
      description:
        'Gränsvärden för temperatur, fuktighet och CO₂ per byggnad och zon.',
      searchPlaceholder: 'Sök bland börvärden …',
      emptyState: 'Inga börvärden ännu.',
      addButton: 'Nytt börvärde',
      loadError: 'Kunde inte hämta börvärdena.',
      zonesLoadError: 'Kunde inte hämta zonerna.',
      saveError: 'Kunde inte spara börvärdet.',
      deleteError: 'Kunde inte ta bort börvärdet.',
      requiredError: 'Dessa fält måste fyllas i:',
      deleteConfirmTitle: 'Ta bort börvärde',
      deleteConfirmMessage:
        'Är du säker på att du vill ta bort detta börvärde? Detta kan inte ångras.',
      editTitle: 'Redigera börvärde',
      newTitle: 'Nytt börvärde',
      editDescription: 'Gränsvärdena gäller för de zoner du väljer.',
      saveButton: 'Spara börvärde',
      openSetpoint: 'Öppna börvärdet',
      buildingSection: 'Byggnad',
      building: 'Byggnad',
      name: 'Namn',
      namePlaceholder: 'T.ex. Kontor standard',
      zonesSection: 'Zoner',
      selectAll: 'Välj alla',
      clearAll: 'Rensa alla',
      noZones: 'Välj en byggnad för att se dess zoner.',
      allZonesTaken: 'Alla zoner i denna byggnad har redan ett börvärde.',
      zonesTakenError: 'En eller flera zoner tillhör redan ett annat börvärde.',
      noZonesSelected: 'Inga zoner valda',
      floor: 'Våning',
      noFloor: '—',
      limitsSection: 'Gränsvärden',
      columns: {
        name: 'Namn',
        building: 'Byggnad',
        zones: 'Zoner',
        inOperation: 'I drift',
        outsideOperation: 'Utanför drift',
        interval: 'Kontrollintervall',
      },
    },
    operatingCalendar: {
      backToList: 'Alla driftkalendrar',
      title: 'Driftkalendrar',
      description:
        'Normal drifttid per byggnad och zon, med extraordinär drift ovanpå.',
      searchPlaceholder: 'Sök bland driftkalendrar …',
      emptyState: 'Inga driftkalendrar ännu.',
      addButton: 'Ny driftkalender',
      running: 'Löpande, utan slutdatum',
      openCalendar: 'Öppna kalendern',
      zonesLoadError: 'Kunde inte hämta zonerna.',
      loadError: 'Kunde inte hämta driftkalendrarna.',
      saveError: 'Kunde inte spara driftkalendern.',
      deleteError: 'Kunde inte radera driftkalendern.',
      requiredError: 'Dessa fält måste fyllas i:',
      deleteConfirmTitle: 'Radera driftkalender',
      deleteConfirmMessage:
        'Är du säker på att du vill radera denna driftkalender? Detta kan inte ångras.',
      editTitle: 'Ange normaldrift',
      editDescription: 'Fast veckodrifttid för de valda zonerna.',
      saveButton: 'Spara normaldrift',
      buildingSection: 'Byggnad',
      building: 'Byggnad',
      zonesSection: 'Zoner',
      selectAll: 'Välj alla',
      clearAll: 'Rensa alla',
      noZonesSelected: 'Inga zoner valda',
      zonesTakenError:
        'En eller flera zoner tillhör redan en annan driftkalender.',
      allZonesTaken:
        'Alla zoner i denna byggnad tillhör redan en driftkalender.',
      noZones: 'Välj en byggnad för att se zonerna.',
      floor: 'Plan',
      noFloor: 'Utan plan',
      validitySection: 'Namn och giltighet',
      name: 'Namn',
      validFrom: 'Gäller från',
      validTo: 'Gäller till',
      weekPlanSection: 'Veckoplan',
      copyMonday: 'Kopiera måndag till alla vardagar',
      noOperation: 'Ingen drift',
      weeklyTotal: 'Summa per vecka',
      from: 'Från',
      to: 'Till',
      calendarTitle: 'Driftkalender',
      week: 'Vecka',
      previousWeek: 'Föregående vecka',
      nextWeek: 'Nästa vecka',
      today: 'I dag',
      editNormal: 'Normaldrift',
      addOverride: 'Lägg in extraordinär drift',
      thisWeek: 'Denna vecka',
      operatingHours: 'Drifttimmar',
      extraordinaryDays: 'Extraordinära dagar',
      upcomingOverrides: 'Kommande extraordinär drift',
      noOverrides: 'Inget planerat.',
      fixedOperation: 'Fast drift',
      publicHoliday: 'Röd dag',
      extraordinary: 'Extraordinär drift',
      closed: 'Stängt',
      opensAt: 'Öppnar',
      closesAt: 'Stänger',
      inOperation: 'I drift',
      outOfOperation: 'Ur drift',
      allDay: 'Hela dagen',
      reason: 'Orsak',
      overrideSaveError: 'Kunde inte spara den extraordinära driften.',
      overrideDeleteError: 'Kunde inte radera.',
      columns: {
        name: 'Namn',
        building: 'Byggnad',
        zones: 'Zoner',
        validity: 'Giltighet',
        hoursPerWeek: 'Timmar/vecka',
      },
      weekdays: {
        mon: 'Mån',
        tue: 'Tis',
        wed: 'Ons',
        thu: 'Tor',
        fri: 'Fre',
        sat: 'Lör',
        sun: 'Sön',
      },
    },
    controlStrategy: {
      list: {
        header: 'Styrstrategier',
        addButton: 'Lägg till styrstrategi',
        emptyState: 'Inga styrstrategier hittades.',
        searchPlaceholder: 'Sök efter byggnad...',
      },
      feedback: {
        saveSuccess: 'Styrstrategi sparad',
        saveError: 'Ett fel uppstod när strategin sparades',
        buildingRequired: 'Byggnad krävs',
        bothHoursRequired: 'Både start- och sluttid måste anges',
        startBeforeEnd: 'Starttiden måste vara före sluttiden',
        deleteSuccess: 'Styrstrategi borttagen',
        deleteError: 'Ett fel uppstod när strategin skulle tas bort',
        confirmDeleteTitle: 'Ta bort styrstrategi',
        confirmDeleteMessage:
          'Är du säker på att du vill ta bort denna styrstrategi? Detta går inte att ångra.',
      },
      schedule: 'Drifttid',
      timezone: 'Tidszon',
      startHour: 'Drifttid start',
      endHour: 'Drifttid slut',
      actions: 'Åtgärder',
      coolingLevel: 'Kylnivå',
      heatingLevel: 'Värmenivå',
      businessHoursControl: 'Styrning under öppettider',
      afterHoursControl: 'Styrning utanför öppettider',
      controlOutsideBusinessHours: 'Styr utanför öppettider',
      tempMin: 'Temp min (°C)',
      tempMax: 'Temp max (°C)',
      co2Min: 'CO₂ min (ppm)',
      co2Max: 'CO₂ max (ppm)',
      actionLabels: {
        cool: 'Kyla',
        heat: 'Värma',
        preCool: 'Förkyla',
        preHeat: 'Förvärma',
        ventilate: 'Ventilera',
        dehumidify: 'Avfukta',
      },
      closed: 'Stängt',
      afterHoursActions: 'Åtgärder utanför drifttid',
    },

    baseline: {
      updated: 'Uppdaterad',
      title: 'Baslinje',
      searchPlaceholder: 'Sök efter baslinje...',
      addButtonLabel: 'Skapa ny baslinje',
      confirmDeleteTitle: 'Ta bort baslinje',
      confirmDeleteMessage:
        'Är du säker på att du vill ta bort denna baslinje?',
      noBaselines: 'Inga baslinjer hittades. Skapa en ny baslinje.',
      createNewBaselineConfirm:
        'Skapa ny baslinje? Detta kommer att skriva över den befintliga.',
      editBaseline: 'Redigera baslinje för',
      calculateBaseline: 'Beräkna baslinje',
      baselineChart: 'Baslinjediagram',
      monthsCovered: 'Månader som ingår',
      excludeMonths: 'Exkludera månader',
      pendingChanges:
        'Osparade ändringar. Klicka på Spara för att uppdatera baslinjen.',
      clickMonthsToExclude: `Klicka på månader för att exkludera dem från baslinjen. Orange månader har en avvikelse på 20 % eller mer från baslinjen.`,
      month: 'Månad',
      energyType: 'Energityp',
      monthlySummary: 'Månatlig sammanfattning',
      weeklySummary: 'Veckovis sammanfattning',
      week: 'Vecka',
      summary: 'Sammanfattning',
      excluded: 'Exkluderad från baslinje',
      energyTypes: {
        electricity: 'Elektricitet',
        districtHeating: 'Fjärrvärme',
        fuel: 'Bränsle',
      },
      overBaseline: 'Över baslinje',
      underBaseline: 'Under baslinje',
      included: 'Inkluderad i baslinje',
      activeLabel: 'Aktiv',
      inactiveLabel: 'Inaktiv',
      lockTooltip: {
        locked: 'Låst — klicka för att tillåta ändringar',
        unlocked: 'Lås för att förhindra ändringar',
      },
      description: 'Skapa och konfigurera baslinjer',
      backButtonLabel: 'Tillbaka till baslinjer',
    },

    topics: {
      addButton: 'Lägg till ämne',
      eosName: 'EOS-namn',
      sensorTag: 'Sensor-tagg',
      sensorTagRequired: 'Sensor-tagg krävs',
      sensorTagTooShort: 'Sensor-tagg måste vara minst 3 tecken',
      assignedTo: 'Används av',
      aggregator: {
        title: 'Aggregator',
        sum: 'Summa',
        average: 'Snitt',
        max: 'Max',
        min: 'Min',
        cumulative: 'Kumulativ',
        differential: 'Differential',
        last: 'Senaste',
      },
      scale: 'Skala',
      decimals: 'Decimaler',
      units: 'Enheter',
      removeButton: 'Ta bort',
      deleteTopic: 'Ta bort ämne',
      confirmDelete: 'Är du säker på att du vill ta bort det här ämnet?',
    },

    /* --------------------------- DEVICE LIST ---------------------------- */
    devices: {
      installNetmoreButton: 'Installera Netmore-enhet',
      gatewayInstaller: 'Installatör för Netmore-gateway',
      gatewayEUI: 'Gateway EUI',
      installChirpStackButton: 'Installera ChirpStack-enhet',
      serialNumber: 'Serienummer',
      bulkSerialsLabel: 'Serienummer (kommaseparerade eller ny rad)',
      ui: {
        singleModeTitle: 'Enskild enhet',
        bulkModeTitle: 'Massinstallation',
        bulkNameHintLine1: 'Namn är tomt -> serienummer används som namn',
        bulkNameHintLine2:
          'Namn är angivet -> alla enheter använder samma namn',
      },
      visualToggle: {
        visualToggleDevice: 'Visuella enheter',
        visualToggleBuilding: 'Byggning',
        visualToggleDelimiter: 'Avgränsare',
        visualToggleDataKey: 'Data Nyckel',
        visualToggleProperty: 'kännetecken',
        visualTogglePropertyId: 'kännetecken-ID',
        visualToggleValue: 'Värde',
        visualToggleColor: 'ärg',
        visualToggleTriggers: 'Utlösare',
        visualToggleAddTrigger: 'Lägg till utlösare',
        visualToggleRemove: 'Ta bort utlösare',
        visualToggleSelectBuilding: 'Välj byggnad',
        visualToggleSelectValue: 'Välj värde',
        visualToggleDev: 'Enhet',
        visualToggleOverview: 'Visuell enhet översikt',
        visualToggleAdd: 'Lägg till Visuell enhet',
        visualToggleGlobalModels: 'Globala 3D-modeller',
        visualToggleDelete: 'Ta bort Visuell enhet',
        visualToggleNoDevices: 'Ingen Visuella enheter hittades.',
        visualToggleSearchPlaceholder: 'Sök Visuella enheter...',
        visualToggleName: 'Namn',
        visualToggleTechnicalRoom: 'Tekniskt rum',
        visualToggleSelectRoom: 'Välj ett tekniskt rum',
        visualToggleBuildingRequired: 'Byggnad krävs',
        visualToggleTechnicalRoomRequired: 'Tekniskt rum krävs',
        visualToggleDeviceRequired: 'Enhet krävs',
        visualtoggleAxes: {
          xAxis: 'Rotation X',
          yAxis: 'Rotation Y',
          zAxis: 'Rotation Z',
          off: 'Av',
          half: 'Halv',
          full: 'Full',
          none: 'Ingen',
        },
        feedback: {
          visualToggleDeleteConfirm:
            'Är du säker på att du vill ta bort den här Visuella enheten?',
          visualToggleDeleteSuccess: 'Visuella enheten har tagits bort',
          visualToggleDeleteError:
            'Ett fel uppstod när Visuella enheten skulle tas bort',
          visualToggleDataKey: 'Saknar datanyckel',
          visualToggleTrigger: 'Saknar trigger',
          visualToggleProperty: 'Egenskap krävs.',
          visualToggleValue: 'Värde krävs.',
          visualToggleUpdated: 'Visuella enheten har uppdaterats',
          visualToggleCreated: 'Visuella enheten har skapats',
          visualToggleSaveError:
            'Ett fel uppstod när Visuella enheten skulle sparas',
        },
      },
      deviceControls: {
        title: 'Enhetskontroller',
        send: 'Skicka',
        updateSuccessMessage: 'Setpunkt uppdaterad',
        updateSuccessTitle: 'Lyckades',
        updateErrorTitle: 'Fel',
        updateErrorMessage: 'Kunde inte uppdatera setpunkt',
        hideAdvanced: 'Dölj avancerade inställningar',
        showAdvanced: 'Visa avancerade inställningar ({count} enheter)',
        current: 'Värde',
        range: 'Från',
        duration: 'Varaktighet (timmar)',
        durationHelp: 'Börvärdet återgår till schemat efter detta',
        comment: 'Kommentar',
        commentPlaceholder: 'Varför överstyrs detta?',
        notLogged: 'Börvärdet är satt, men överstyrningen kunde inte loggas',
      },
      list: {
        header: 'Enhetshantering',
        addButton: 'Lägg till enhet',
        emptyState: 'Inga enheter hittades.',
        searchPlaceholder: 'Sök enheter…',
        backButton: 'Tillbaka till enheter',
      },
      validation: {
        nameRequired: 'Enhetsnamn krävs',
        sensorTagMissing: 'Sensor-tagg saknas för ämne {{index}}.',
        sensorTagTooShort:
          'Sensor-tagg för ämne {{index}} måste vara minst 3 tecken lång.',
      },
      feedback: {
        updateSuccess: 'Enheten uppdaterades',
        updateError: 'Fel vid UPPDATERING av enheten',
        createSuccess: 'Enheten skapades',
        installSuccess: 'Enheten installerades',
        createError: 'Fel vid SKAPANDE av enheten',
        duplicateDevice: 'Enhet med detta serienummer finns redan.',
        saveError: 'Fel vid SPARANDE av enheten',
        missingAttributes: 'Vissa obligatoriska attribut saknas',
        validationError: 'Valideringsfel',
        serviceUnavailable:
          'Tjänsten är tillfälligt otillgänglig. Försök igen senare.',
        bulkInstallSummary:
          'Installerade: {installed}. Dubbletter: {duplicates}. Misslyckade: {failed}.',
      },
    },

    /* -------------------------- EOS DEVICE LIST ------------------------- */
    eosDevices: {
      energyCategories: {
        electricityGrid: 'El (nät)',
        electricityGridExport: 'Exporterad el (nät)',
        districtHeating: 'Fjärrvärme',
        districtCooling: 'Fjärrkyla',
        fossilFuels: 'Fossila bränslen',
        biofuels: 'Biobränslen',
        solarPV: 'Solceller',
        solarThermal: 'Solvärme',
        otherRenewables: 'Annan förnybar energi (vind, geotermisk)',
        wasteHeat: 'Spillvärme',
      },
      list: { header: 'EOS-enheter' },
      validation: {
        sensorTagMissing: 'Sensor-tagg saknas för ämne {{index}}.',
        sensorTagTooShort:
          'Sensor-tagg för ämne {{index}} måste vara minst 3 tecken lång.',
      },
      feedback: {
        updateSuccess: 'Enheten uppdaterades',
        updateError: 'Fel vid UPPDATERING av enheten',
        createSuccess: 'Enheten skapades',
        createError: 'Fel vid SKAPANDE av enheten',
        saveError: 'Fel vid SPARANDE av enheten',
      },
    },

    /* --------------------------- EDIT DEVICE ---------------------------- */
    editDevice: {
      newTitle: 'Ny enhet',
      deviceName: 'Enhetsnamn',
      deviceDescription: 'Enhetsbeskrivning',
      deviceProfile: 'Enhetsprofil',
      selectDeviceProfile: '- Välj enhetsprofil',
      setpointRange: 'Setpoint-område',
      setpointRangeInfo:
        'Ange övre och undre setpoint-värde för sensortaggen, samt stegstorleken som ska tas mellan setpoint-värdena.',
      minSetpoint: 'Låg Setpoint',
      maxSetpoint: 'Hög Setpoint',
      stepSize: 'Stegstorlek',
      controlMode: {
        label: 'Styrläge',
        info: 'Bestämmer hur enheten regleras när styrning utlöses.\nSteg: Justerar setpointen gradvis upp/ner med stegstorleken per körning, inom min/max.\nBinär: Hoppar direkt till max (mer värme/ventilation) eller min (mindre). På/av-styrning.\nSchema: Följer endast öppettiderna — max inom, min utanför. Ignorerar ASPA-åtgärder.\nSetpoint: Skriver önskad setpoint direkt, begränsad till min/max. Uppdaterar endast vid avvikelse över ±0,1.',
        step: 'Steg',
        binary: 'Binär',
        schedule: 'Schema',
        setpoint: 'Setpoint',
      },
      operatingHoursOnly: 'Styrs endast inom drifttid',
      dynamicSetpoints: {
        label: 'Dynamiska setpoints',
        info: 'Dynamiska setpoints låter enheten åsidosätta sitt setpoint-område baserat på andra sensorvärden. När sensorvärdet i sensor-taggen uppfyller villkoret (operator + tröskelvärde) används låg setpoint, hög setpoint och stegstorlek från raden i stället för enhetens vanliga setpoint-område.\nSensor-tagg: sensor-taggen som övervakas (t.ex. styrsignal till kylbatteri).\nOperator/tröskelvärde: villkoret som måste vara uppfyllt för att åsidosättningen ska vara aktiv.\nLåg/hög setpoint och stegstorlek: setpoint-området som gäller så länge villkoret är uppfyllt.',
        add: 'Lägg till dynamisk setpoint',
        deleteTitle: 'Ta bort dynamisk setpoint',
        confirmDelete:
          'Är du säker på att du vill ta bort denna dynamiska setpoint?',
        operator: 'Operator',
        threshold: 'Tröskelvärde',
        validationError:
          'Alla fält måste fyllas i för att lägga till en dynamisk setpoint.',
        fieldRequired: 'Obligatoriskt',
      },
      controllerSettings: 'Styrenhetsinställningar',
      status: {
        active: 'Aktiv',
        displayInZone: 'Visa i zon',
      },
      display: 'Visning',
      icon: 'Ikon',
      deviceType: {
        label: 'Enhetstyp',
        selectDefault: '- Välj enhetstyp -',
        sensor: 'Sensor',
        controller: 'Styrenhet',
      },
      dataReceiver: {
        label: 'Datamottagare',
        selectDefault: '- Välj datamottagare',
        info: 'Ange vilken mottagare som ska ta emot styrvärden för denna enhet.',
      },
      deviceCategory: {
        label: 'Enhetskategori',
        selectDefault: 'Välj kategori',
      },
      valueMap: 'Kartlägg enhetsvärden till text (valfritt)',
      setValueMapping: 'Ange värdekartläggning',
      mappedAttribute: {
        label: 'Kartlagt attribut',
        attribute: 'Attribut',
        numberValue: 'Nummer',
        textValue: 'Text',
        duplicateValueMapping: 'Detta värde finns redan!',
        cancelEditValueMapping: 'Avbryt',
        removeValueMapping: 'Ta bort',
        editValueMapping: 'Redigera',
        deleteTitle: 'Ta bort värdekartläggning',
        confirmDeleteValueMapping:
          'Är du säker på att du vill ta bort denna värdekartläggning?',
        confirmDeleteMappedAttributeTitle: 'Ta bort kartlagt attribut',
        confirmDeleteMappedAttribute:
          'Är du säker på att du vill ta bort detta kartlagda attribut?',
      },
      topics: 'Ämnen',
      inspectDevice: 'Inspektera enhet',
      deleteButton: {
        deleting: 'Tar bort…',
        label: 'Ta bort enhet',
      },
      confirmDelete: 'Är du säker på att du vill ta bort enheten?',
      title: 'Redigera enhet',
    },

    /* ------------------------- EDIT EOS DEVICE ------------------------- */
    editEosDevice: {
      title: 'Redigera EOS-enhet',
      newTitle: 'Ny EOS-enhet',
      deviceName: 'Enhetsnamn',
      topics: 'Ämnen',
      deviceDescription: 'Enhets­beskrivning',
      active: 'Aktiv',
      producingPower: 'Producerar effekt',
      includeInBaseline: 'Inkludera i baslinjen',
      deviceSettings: 'Enhetsinställningar',
      energyCategory: { label: 'Energikategori' },
      provider: {
        label: 'Leverantör',
        required: 'Leverantör krävs för fjärrvärme',
        options: {
          hafslund: 'Hafslund (Celsio)',
          luneraEnergi: 'Lunera Energi',
        },
      },
      building: 'Byggnad',
      allBuildings: 'Alla byggnader',
      sensorTypes: {
        HEAT: 'Värme',
        LIGHT: 'Ljus',
        HVAC: 'HVAC',
        PRODUCTION: 'Produktion',
        OFFICE: 'Kontor',
        OTHER: 'Övrigt',
      },
      icon: 'Ikon',
      deviceType: {
        label: 'Enhetstyp',
        selectDefault: '- Välj enhetstyp -',
        eosSensor: 'EOS-sensor',
        eosSource: 'EOS-källa',
      },
      sensorConfiguration: 'Sensor­konfiguration',
      deviceCategory: {
        label: 'Enhetskategori',
        selectDefault: 'Välj kategori',
      },
      sources: 'Källor',
      inspectDevice: 'Inspektera enhet',
      deleteButton: {
        deleting: 'Tar bort…',
        label: 'Ta bort EOS-enhet',
      },
      confirmDelete: 'Är du säker på att du vill ta bort enheten?',
    },

    /* ---------------------------- CATEGORIES --------------------------- */
    categories: {
      list: {
        header: 'Kategorier',
        addButton: 'Lägg till kategori',
        emptyState: 'Inga kategorier hittades.',
        searchPlaceholder: 'Sök kategorier…',
        backButton: 'Tillbaka till kategorier',
      },
      feedback: {
        updateSuccess: 'Kategorin uppdaterades',
        updateError: 'Fel vid UPPDATERING av kategorin',
        createSuccess: 'Kategorin skapades',
        createError: 'Fel vid SKAPANDE av kategorin',
        saveError: 'Fel vid SPARANDE av kategorin',
      },
    },
    editCategory: {
      parentCategory: 'Förälderkategori',
      legend: 'Språk',
      categoryName: 'Kategorinamn:',
      languageType: 'Språktyp:',
      selectLanguage: 'Välj språk',
      categoryDescription: 'Kategori­beskrivning:',
      deleteCategory: 'Ta bort kategori',
      deleteConfirm: 'Är du säker på att du vill ta bort kategorin?',
      categoryType: 'Kategorityp',
      validation: {
        categoryRequired: 'Minst en kategorityp krävs',
        languageRequired: 'Språk krävs',
      },
      languageOptions: {
        en: 'Engelska',
        no: 'Norska',
        se: 'Svenska',
        de: 'Tyska',
        fr: 'Franska',
        es: 'Spanska',
      },
      categoryTypes: {
        device: 'Enhet',
        zone: 'Zon',
        service: 'Tjänst',
        resource: 'Resurs',
        activity: 'Aktivitet',
      },
    },

    /* --------------------------- USER MANAGEMENT ----------------------- */
    userManagement: {
      auditLogs: {
        viewed: 'Läst',
        doneBy: 'Utförd av',
        noAccess:
          'Du behöver nivå 4 (systemadministratör) eller högre för att se granskningsloggar.',
      },
      auditChanges: {
        readQuery: 'Vad som lästes',
        title: 'Vad ändrades',
        field: 'Fält',
        before: 'Före',
        after: 'Efter',
        created: 'Skapad',
        updated: 'Uppdaterad',
        deleted: 'Raderad',
        empty: 'Inga ändringar i databasen registrerades för denna begäran.',
        more: 'Fler poster ändrades än vad som visas här.',
        hidden: 'Dold',
        largeValue: 'Stort värde',
        items: 'element',
        sentData: 'Skickad data',
      },
      list: {
        header: 'Användar­hantering',
        addButton: 'Lägg till användare',
        emptyState: 'Inga användare hittades.',
        searchPlaceholder: 'Sök användare…',
        backButton: 'Tillbaka till användare',
      },
      feedback: {
        fetchError: 'Fel vid hämtning av användare',
        updateSuccess: 'Användaren uppdaterades',
        updateError: 'Fel vid UPPDATERING av användaren',
        createSuccess: 'Användaren skapades',
        createError: 'Fel vid SKAPANDE av användaren',
        saveError: 'Fel vid SPARANDE av användaren',
      },
    },

    editUser: {
      firstName: 'Förnamn',
      lastName: 'Efternamn',
      userInformation: 'Användar­information',
      mobileNumber: 'Mobilnummer',
      email: 'E-post',
      password: 'Lösenord',
      enovaOrganization: 'Organisation',
      enovaOrganizationNumber: 'Organisationsnummer',
      enovaPersonalGuid: 'Enova GUID',
      azureAccount: 'Azure-konto-ID',
      role: 'Roll',
      active: 'Aktiv',
      acceptEmails: 'Acceptera e-post',
      receiveEmails: 'Användaren får system­mail',
      canLogin: 'Användaren kan logga in',
      hideFeedback: 'Dölj feedback',
      hidePopups: 'Dölj feedback-popup',
      changePassword: 'Byt lösenord',
      successUpdatePassword: 'Lösenordet uppdaterades',
      errorUpdatePassword: 'Kunde inte uppdatera lösenordet',
      passwordFeedback: 'Lösenordet måste vara minst 8 tecken',
      addNew: 'Lägg till ny användare',
      calendarSetup: 'Kalenderinställningar',
      calendarStartOfDay: 'Dagens start (för kalendervyn)',
      calendarEndOfDay: 'Dagens slut',
      tenantAccess: {
        header: 'Hyres­tillgång',
        label: 'Hyresgäst',
        addAccess: 'Lägg till tillgång',
        selectTenant: '- Välj hyresgäst -',
        assignedTenants: 'Tilldelade hyresgäster',
        fetchFailed: 'Kunde inte hämta hyresgäster',
        feedback: {
          pleaseSelect: 'Välj en hyresgäst',
          alreadyAdded: 'Hyresgäst redan tillagd',
        },
      },
      deleteUser: {
        label: 'Ta bort användare',
        deleting: 'Tar bort…',
      },
      confirmDelete: 'Är du säker på att du vill ta bort användaren?',
      activityLog: 'Aktivitetslogg',
    },

    /* ------------------------ INTEGRATION OVERVIEW --------------------- */
    integrationOverview: {
      edit: {
        details: {
          legend: 'Detaljer',
          nameLabel: 'Namn',
          activeLabel: 'Aktiv',
        },
        access: {
          legend: 'Åtkomst',
          accessLevelLabel: 'Åtkomstnivå',
          dateFromLabel: 'Från datum',
          dateToLabel: 'Till datum',
          accessLevelOptions: {
            noAccess: 'Ingen åtkomst',
            readOnly: 'Skrivskydd',
            readAndWrite: 'Läs och skriv',
            admin: 'Admin',
          },
        },
        secrets: {
          legend: 'Nycklar',
          revealButton: 'Visa',
          publicKeyLabel: 'Publik nyckel',
          secretKeyLabel: 'Hemlig nyckel',
        },
      },
      feedback: {
        updateSuccess: 'Integration uppdaterad',
        createSuccess: 'Integration skapad',
        saveError: 'Kunde inte spara',
        fetchSecretsError: 'Kunde inte hämta nycklar',
        fetchIntegrationsError: 'Kunde inte hämta integrationer',
      },
    },

    /* -------------------------- THEME SETTINGS ------------------------- */
    themeSettings: {
      header: {
        title: 'Teman',
        subtitle: 'Skapa och hantera företagets visuella teman',
      },
      feedback: {
        activatedSuccess: 'Temat {themeName} aktiverades',
        deletedSuccess: 'Temat togs bort',
        updatedSuccess: 'Temat uppdaterades',
        createdSuccess: 'Temat skapades',
      },
      card: {
        customize: 'Anpassa',
        fallbackDescription: 'Ett {name}-tema',
        confirmDelete: 'Är du säker på att du vill ta bort temat "{name}"?',
      },
      globalThemes: {
        sunsetOrange: {
          name: 'Solnedgångsorange',
          description: 'Varma orange och korall toner med sandiga accenter',
        },
        oceanBlue: {
          name: 'Havsblå',
          description: 'Friska blå toner inspirerade av havet',
        },
        crimsonRed: {
          name: 'Karmosinröd',
          description: 'Djup karmosin driven av energiska röda toner',
        },
        forestGreen: {
          name: 'Skogsgrön',
          description: 'Lugnande skogsgröna toner med naturliga accenter',
        },
        blackAndWhite: {
          name: 'Svart & vitt',
          description: 'Tidlös svart och vit kontrast för en modern look',
        },
        classicGray: {
          name: 'Klassisk grå',
          description: 'Professionellt grått tema med subtila kontraster',
        },
        modernWhite: {
          name: 'Modern vit',
          description: 'Tidlös vit för en ren, minimalistisk estetik',
        },
      },
      dialog: {
        editHeader: 'Redigera tema',
        createHeader: 'Skapa tema',
        createTitle: 'Skapa nytt tema',
        createDescription:
          'Designa ett anpassat tema med dina färger och din stil',
        namePlaceholder: 'Namn på ditt tema',
        descriptionPlaceholder: 'Beskriv ditt tema (valfritt)',
        iconHover: 'Ikon vid hover',
        nameRequired: 'Temanamn krävs',
        customSuffix: '(Anpassad)',
      },
    },

    /* ----------------------------- VENDOR ------------------------------ */
    vendor: {
      title: 'Allmänt',
      form: {
        name: 'Namn',
        contactDetails: 'Kontaktuppgifter',
        street: 'Gata',
        postcode: 'Postnummer',
        city: 'Stad',
        country: 'Land',
        timezone: 'Tidszon',
        selectTimezone: 'Välj tidszon',
        organizationNumber: 'Org.nr',
        phone: 'Kontakt­telefon',
        email: 'Kontakt­e-post',
        website: 'Länk till webbplats',
        languageDefault: 'Standardspråk',
        selectLanguage: 'Välj språk',
      },
      modules: {
        title: 'Moduler',
        threeDView: '3D-vy',

        requiredAttributes: {
          title: 'Obligatoriska fält',
          firstName: 'Förnamn',
          lastName: 'Efternamn',
          phone: 'Telefon',
          email: 'E-post',
        },
        buildingAutomation: {
          title: 'Byggnads­automation',
          sastechTenantId: 'Sastech-hyr­ID',
          ignitionProjectName: 'Ignition projektnamn',
          gridRegion: 'Nätområde',
          selectGridRegion: '- Välj område -',
          gridRegions: {
            NO1: 'Østlandet NO1',
            NO2: 'Sørlandet NO2',
            NO3: 'Midt-Norge NO3',
            NO4: 'Nord-Norge NO4',
            NO5: 'Vestlandet NO5',
          },
        },
        publicDisplay: {
          title: 'Publik display',
          loginToDisplay: 'Logga in till display',
          invalidPassword: 'Ogiltigt lösenord. Försök igen.',
          password: 'Lösenord',
          publicLink: 'Public display-länk:',
          description:
            'Visa nyckeltal för byggnaden på en publik skärm utan gränssnitt',
          placeholder: 'Ange nytt lösenord',
          leaveBlankHint: 'Lämna tomt för att behålla nuvarande lösenord.',
          copyButton: 'Kopiera',
          copySuccess: 'Länken kopierades',
          saveVendorFirst: 'Spara leverantören för att skapa en token',
          regenerateButton: 'Återskapa token',
          regenerateWarning:
            'Varning: detta ogiltigförklarar den nuvarande länken',
          confirmRegenerate:
            'Är du säker på att du vill återskapa token? Den nuvarande länken ogiltigförklaras.',
          tokenRegenerated: 'Token återskapades',
          tokenRegenerateFailed: 'Kunde inte återskapa token',
        },
      },
      logo: {
        title: 'Logotyp',
      },
      privacy: {
        title: 'Integritet och anonymisering',
        activateAnonymizing: 'Aktivera anonymisering',
        privacyPolicyText: 'Här ställer du in anonymiserings­intervallet',
        monthsToKeepData: 'Antal månader att behålla data',
      },
      keyAccountManager: {
        title: 'Key Account-ansvarig',
        notAssigned: 'Ej tilldelad',
      },
      tenantStatus: {
        title: 'Hyresgäst­status',
        tenantIsActive: 'Hyresgästen är aktiv',
        status: 'Status',
        options: {
          development: '1. Utveckling',
          readyForProduction: '2. Klar för produktion',
          production: '3. Produktion (system)',
          deleted: 'Raderad',
        },
        markedForDeletion: 'Markerad för borttagning',
        vendorDeletionTitle: 'Borttagning av leverantör',
        vendorDeletionDescription:
          'Leverantören tas bort endast om den är markerad för borttagning, status är "raderad" och den är inaktiv. Dessutom måste den ha varit orörd i minst 30 dagar.',
      },
      vendorIdLabel: 'Leverantörs-ID',
      successMessage: 'Leverantören uppdaterades',
      successMessagePassword: 'Leverantören uppdaterades (lösenord ändrat)',
      errorMessage: 'Det gick inte att uppdatera leverantören',
    },

    /* -------------------------- IMAGE / FILE UPLOAD -------------------- */
    imageUpload: {
      uploadImage: 'Ladda upp bild',
      noFileSelected: 'Ingen fil vald',
      uploading: 'Laddar upp…',
      fileSizeExceeded: 'Filstorleken överstiger {{size}} MB.',
      invalidFileType: 'Ogiltig filtyp. Välj en bild.',
      uploadFailed: 'Uppladdning misslyckades. Försök igen',
      bytes: 'byte',
      dropToReplace: 'Släpp bild för att ersätta',
      dragHint: 'Dra och släpp här för att ersätta',
      fromFileCloud: 'Filmoln',
      chooseFromFileCloud: 'Välj från Filmoln',
      convertingHeic: 'Konverterar HEIC bild…',
      heicConversionFailed:
        'Kunde inte konvertera HEIC bilden. Prova en JPEG eller PNG i stället.',
      uploadProgress: 'Laddar upp {{done}} av {{total}}…',
      uploadFailedFiles: 'Kunde inte ladda upp: {{names}}',
    },

    fileUpload: {
      uploadImage: 'Ladda upp fil',
      noFileSelected: 'Ingen fil vald',
      uploading: 'Laddar upp…',
      fileSizeExceeded: 'Filstorleken överstiger {{size}} MB.',
      invalidFileType: 'Ogiltig filtyp. Välj en giltig fil.',
      uploadFailed: 'Uppladdning misslyckades. Försök igen',
      fileAlreadyUploaded: 'Filen är redan uppladdad',
      uploadFile: 'Ladda upp fil',
      viewUploadedFile: 'Visa uppladdad fil',
      uploadNewFile: 'Ladda upp ny fil',
      fileLabel: 'Fil:',
      sizeLabel: 'Storlek:',
    },

    /* ------------------------------- FILE CLOUD ------------------------ */
    fileCloud: {
      title: 'Fil-moln',
      header: 'Lagra, organisera och dela filer säkert i organisationen',
      nameLabel: 'Namn',
      folderLabel: 'Mapp',
      sizeLabel: 'Storlek',
      dateLabel: 'Datum uppdaterad',
      buildingLabel: 'Byggnad',
      currentPath: 'Aktuell sökväg',
      rootLabel: 'Hem',
      selectedLabel: 'valda',
      gridViewLabel: 'Rutnätsvy',
      listViewLabel: 'Listvy',
      uploadFiles: {
        dropZonePrompt: 'Dra och släpp fil(er) här',
        selectedFilesHeader: 'Valda filer:',
        uploadButton: 'Ladda upp',
        uploadFilesLabel: 'Ladda upp filer',
        uploadFolderLabel: 'Ladda upp mapp',
        uploadProgress: 'Laddar upp {{done}} av {{total}} filer…',
      },
      noFiles: 'Dra och släpp filer',
      noBuildings: 'Inga byggnader tillgängliga.',
      menu: {
        download: 'Ladda ned',
        rename: 'Byt namn',
        delete: 'Ta bort',
        setBuilding: 'Koppla byggnad',
        clearBuilding: 'Ta bort koppling',
      },
      dialog: {
        buildingTitle: 'Välj byggnad',
        cancelButton: 'Avbryt',
        newFolderName: 'Mappnamn',
        createFolder: 'Skapa mapp',
        renameFolder: 'Byt namn på mapp',
        confirmDeleteTitle: 'Radera fil',
        confirmDeleteMessage:
          'Är du säker på att du vill radera den valda filen?',
        confirmFolderDeleteMessage:
          'Är du säker på att du vill radera den valda mappen och allt dess innehåll?',
        invalidFolderName:
          'Mappnamnet innehåller ogiltiga tecken eller är tomt.',
        duplicateFolderName: 'En mapp med detta namn finns redan.',
        confirmDeleteSelectedMessage:
          'Är du säker på att du vill ta bort de valda filerna?',
      },
      feedback: {
        // existing
        fileDeleted: 'Filen har tagits bort',
        buildingCleared: 'Byggnaden har rensats',
        buildingAssigned: 'Byggnaden har tilldelats',
        buildingUpdateError: 'Det gick inte att uppdatera byggnadskopplingen.',

        // Restore file
        fileRestored: 'Filen har återställts.',
        restoreSuccessfulTitle: 'Återställning lyckades',
        restoreErrorMessage: 'Det gick inte att återställa filen.',
        restoreErrorTitle: 'Återställningsfel',

        // Empty garbage
        garbageEmptied: 'Papperskorgen har tömts.',
        emptyGarbageSuccessfulTitle: 'Tömning av papperskorgen lyckades',
        emptyGarbageErrorMessage: 'Det gick inte att tömma papperskorgen.',
        emptyGarbageErrorTitle: 'Fel vid tömning av papperskorgen',

        // Move folder to garbage
        folderMovedToGarbage: 'Mappen har flyttats till papperskorgen.',
        moveFolderToGarbageSuccessfulTitle: 'Flytt till papperskorgen lyckades',
        moveFolderToGarbageErrorMessage:
          'Det gick inte att flytta mappen till papperskorgen.',
        moveFolderToGarbageErrorTitle: 'Fel vid flytt till papperskorgen',

        // Rename folder
        folderRenamed: 'Mappen har bytt namn.',
        renameFolderSuccessfulTitle: 'Namnbyte lyckades',
        renameFolderErrorMessage: 'Det gick inte att byta namn på mappen.',
        renameFolderErrorTitle: 'Namnbytesfel',

        // Move folder
        folderMoved: 'Mappen har flyttats.',
        moveFolderSuccessfulTitle: 'Flytt lyckades',
        moveFolderErrorMessage: 'Det gick inte att flytta mappen.',
        moveFolderErrorTitle: 'Fel vid flytt',

        // Delete file
        deleteSuccessfulTitle: 'Borttagning lyckades',
        deleteErrorMessage: 'Det gick inte att ta bort filen.',
        deleteErrorTitle: 'Borttagningsfel',

        // Move file
        moveFileErrorMessage: 'Det gick inte att flytta filen.',
        moveFileErrorTitle: 'Flyttfel',

        // Create folder
        createFolderErrorMessage: 'Det gick inte att skapa mappen.',
        createFolderErrorTitle: 'Fel vid skapande av mapp',

        // Upload
        uploadSuccessfulMessage: 'Filerna har laddats upp.',
        uploadSuccessfulTitle: 'Uppladdning lyckades',
        uploadErrorTitle: 'Uppladdningsfel',
      },

      newFolder: 'Ny mapp',
      confirmDeleteFolder:
        'Är du säker på att du vill ta bort mappen och alla dess filer?',
      moveToRoot: 'Flytta till rotmappen',
    },

    /* -------------------------- GENERIC FEEDBACK ----------------------- */
    feedback: {
      vendorLoad: {
        title: 'Fel',
        message: 'Kunde inte läsa in leverantörsinformation',
      },
    },
    degreeDays: {
      error: 'Byggnaden saknar GPS-koordinater',
    },
  },
  feedback: {
    open: 'Feedback',
    title: 'Skicka feedback',
    close: 'Stäng',
    messageLabel: 'Meddelande',
    placeholder: 'Skriv din feedback här…',
    screenshotTitle: 'Ladda upp skärmdump',
    send: 'Skicka',
    infoPrefix: 'För mer information, se',
    helpCenter: 'Hjälpcenter',
    statusPage: 'Statussida',
  },
  admin: {
    buildingInspection: BUILDING_INSPECTION,
    energyLabelLeads: ENERGY_LABEL_LEADS,
    siteInspection: {
      deleteNoSiteInspectionsMessage:
        'Ingen byggnadsbesiktning vald för borttagning.',
      deleteConfirmMessage:
        'Är du säker på att du vill ta bort denna byggnadsbesiktning? Detta kan inte ångras.',
      deleteSuccessMessage: 'Byggnadsbesiktningen har tagits bort.',
      deleteErrorMessage: 'Kunde inte ta bort byggnadsbesiktningen.',
      updateSuccessMessage: 'Byggnadsbesiktningen har uppdaterats.',
      createSuccessMessage: 'Byggnadsbesiktningen har skapats.',
      failedToLoadMessage:
        'Kunde inte ladda in byggnadsbesiktningar. Försök igen senare.',
      saveErrorMessage:
        'Kunde inte spara byggnadsbesiktningen. Försök igen senare.',
      buildingErrorMessage:
        'Vänligen välj en byggnad för byggnadsbesiktningen.',
      buildingTypeErrorMessage:
        'Vänligen välj en byggnadstyp för byggnadsbesiktningen.',
      failedToLoadBuildingsMessage:
        'Kunde inte ladda in byggnader. Försök igen senare.',
      calculationsCompleteMessage: 'Beräkningarna är klara',
      //Header
      title: 'Byggnadsbesiktning',
      subtitle:
        'Slutför byggnadsbesiktningen genom att använda formuläret nedan',
      newInspectionLabel: 'Ny besiktning, spara för att aktivera fler val.',
      reportLabel: 'Rapport',
      actionsLabel: 'Åtgärder',
      generalLabel: 'Allmänt',
      //Info
      status: {
        statusLabel: 'Status',
        draft: 'Utkast',
        completed: 'Slutförd',
        inReview: 'Under granskning',
      },
      buildingLabel: 'Byggnad',
      buildingTypeLabel: 'Byggnadstyp (NS-standard)',
      notesLabel: 'Anteckningar',
      buildingTypes: {
        label: {
          smallHouse: 'Småhus',
          apartmentBlock: 'Flerbostadshus',
          kinderGarden: 'Förskola',
          officeBuilding: 'Kontorsbyggnad',
          schoolBuilding: 'Skolbyggnad',
          universityCollege: 'Universitet / Högskola',
          hospital: 'Sjukhus',
          nursingHome: 'Vårdhem',
          hotel: 'Hotell',
          sportsBuilding: 'Idrottsbyggnad',
          commercialBuilding: 'Affärsbyggnad',
          culturalBuilding: 'Kulturbyggnad',
          lightIndustryWarehouse: 'Lätt industri / Lagerbyggnad',
        },
        description: {
          smallHouse:
            'Friliggande hus, parhus, radhus, kedjehus eller andra små bostäder.',
          apartmentBlock:
            'Flerbostadshus med två eller flera våningar, inklusive större radhus med flera våningar.',
          kinderGarden:
            'Byggnader avsedda för förskola eller tidig barndomsutbildning.',
          officeBuilding:
            'Enkla kontor, kontor med ventilation och kyla, eller utställnings- och kongressbyggnader.',
          schoolBuilding:
            'Undervisningslokaler, inklusive skolor med simhall eller idrottshall.',
          universityCollege:
            'Universitets- eller högskolebyggnader, laboratorier eller forskningsanläggningar.',
          hospital:
            'Sjukhus, patienthotell eller laboratorier för medicinskt bruk.',
          nursingHome: 'Vårdhemsbyggnader för långtidsboende och omsorg.',
          hotel: 'Hotell, restaurangbyggnader eller andra byggnader för logi.',
          sportsBuilding:
            'Idrottshallar, simhallar och andra idrottsanläggningar med omklädnings- och duschutrymmen.',
          commercialBuilding:
            'Butiker, lokaler med kyl- eller frysanläggningar, eller bensinstationer.',
          culturalBuilding:
            'Biografer, museer, bibliotek och religiösa byggnader.',
          lightIndustryWarehouse:
            'Industribyggnader, lager, fiske-/jordbruksbyggnader, energianläggningar eller andra verkstäder.',
        },
      },
      mainTabs: {
        info: 'Information',
        climate: 'Klimat',
        zones: 'Zoner',
        hvac: 'Ventilation och drift',
        heatingCooling: 'Uppvärmning och kylning',
        excessEnergy: 'Överskottsenergi',
        analytics: 'Analys',
        attachments: 'Bilagor',
      },
      footerButtons: {
        next: 'Nästa',
        previous: 'Föregående',
      },
      climate: {
        averageMonthlyTemp: 'Genomsnittlig månadstemperatur (°C)',
        globalIrradiation: 'Global solinstrålning (kWh/m²)',
        diffuseIrradiation: 'Diffus solinstrålning (kWh/m²)',
        albedo: 'Albedo (0–1)',
      },
      hvacTabs: {
        hvacUnits: 'Ventilationsaggregat',
        operationalLoads: 'Driftslaster',
        productionEquipment: 'Produktionsutrustning',
      },
      zoneManager: {
        area: 'Area (m²)',
        noZonesCreatedYet: 'Inga zoner skapade ännu.',
        createZoneToBegin: `Skapa en zon för att börja samla in data om klimatskalet. 
        Du kan antingen välja en befintlig byggnadszon eller skapa en ny specifikt för denna platsbesiktning.`,
        subTabs: {
          buildingEnvelope: 'Byggnadsskal',
          windows: 'Fönster',
          doors: 'Dörrar',
          gates: 'Portar',
          airLeakage: 'Luftläckage',
          thermalMass: 'Termisk massa',
        },
        zoneSelector: {
          createFirstZone: 'Skapa första zonen',
          addZone: 'Lägg till zon',
          deleteSelectedZone: 'Ta bort vald zon',
          linked: 'Länkad',
        },
        zoneCreateModal: {
          zoneNameError: 'Zonens namn krävs.',
          createNewZoneLabel: 'Skapa ny zon',
          linkExistingZoneLabel: 'Länka befintlig zon',
          linkExistingZoneHelperText:
            'Välj en befintlig zon att länka till denna besiktning.',
          selectZonePlaceholder: 'Välj en zon...',
          createNewZoneHelperText:
            'Skapa en ny zon som läggs till byggnaden och används för denna besiktning.',
          zoneName: 'Zonens namn',
          description: 'Beskrivning',
          cancelButtonLabel: 'Avbryt',
          addZoneTitle: 'Lägg till zon',
          zoneNameLabel: 'Zonnamn',
          descriptionLabel: 'Beskrivning',
        },
        exteriorWalls: 'Ytterväggar',
        helperWithHistory: {
          north: 'Norr',
          south: 'Söder',
          east: 'Öster',
          west: 'Väst',
          count: 'Antal',
          width: 'Bredd (m)',
          height: 'Höjd (m)',
          addToArea: 'Lägg till area (m²)',
          history: 'Historia ',
          entry: ' Beräkning',
          entries: ' Beräkningar',
          inputHistory: 'Beräkningshistorik',
          helperTitle: 'Areakalkylator',
        },
        windows: {
          glassType: 'Glas typ',
          windowTypes: [
            'None',
            'Enkelglas',
            '2-glas',
            '2-glas energiglas',
            '2-glas solreflekterande',
            '3-glas energiglas',
          ],
          totalWindowsArea: 'Total fönsterarea (m²)',
          sumOfAllWindowsSurfaces: 'Summa av alla fönsterytor',
          averageUValue: 'Genomsnittligt U-värde (W/m²K)',
          averageUValueFormula: '(Σ(U × area)) / Σ(area)',
          winAreaAsPercentageOfFacade: 'Fönsterarea som % av fasad',
          winAreaAsPercentageOfFacadeFormula:
            'Total fönsterarea / Total fasadarea × 100',
        },
        buildingEnvelope: {
          bra: 'Uppvärmd användbar area (m²)',
          floors: 'Antal våningar',
          floorHeight: 'Våningshöjd (m)',
          indoorTemperature: 'Inomhustemperatur (°C)',
          heatedVolume: 'Uppvärmd luftvolym (m³)',
          heatedVolumeFormula: 'Uppvärmd användbar area × våningshöjd',
          thermalBridge: 'Termisk bro',
          thermalBridgeFormula: 'Uppvärmd area × normvärde × Kelvin',
          totalExternalWallArea: 'Total area av ytterväggar',
          totalExternalWallAreaFormula: 'Summa av ytterväggsytor',
          thermalBridgeCoefficient: 'Termisk brokoefficient (W/mK)',
          extwWallConstruction: 'Ytterväggskonstruktiontyp',
          groundConditions: {
            title: 'Markförhållanden',
            options: {
              none: 'Ingen',
              clay: 'Lera',
              drySandGravel: 'Sand/grus (torr)',
              moistSandGravel: 'Sand/grus (fuktig)',
              wetSandGravel: 'Sand/grus (våt)',
              rock: 'Berg',
              moraine: 'Morän',
              dryPeat: 'Torv (torr)',
              moistPeat: 'Torv (fuktig)',
              wetPeat: 'Torv (våt)',
              silt: 'Silt',
              organicSoil: 'Organisk jord',
            },
            heatCapacity: 'Värmekapacitet (J/m²K)',
            thermalConductivity: 'Termisk ledningsförmåga (W/mK)',
            groundTemperature: 'Marktemperatur (°C)',
          },
          grossArea: 'Bruttoarea (m²)',
          netArea: 'Nettoarea (m²)',
          netAreaFormula: 'Väggarea - Fönster - Dörrar - Portar',
          wallConstruction: {
            title: 'Väggkonstruktion',
            // We are going to change wall construction type so translations will come later here
          },
          uValue: 'U-värde (W/m²K)',
          shadingFactor: 'Skuggfaktor',
          area: 'Area (m²)',
          yearInstalled: 'Installationsår',
          yearInstalledNone: 'Ingen',
          yearInstalledBefore1949: 'Före 1949',
          yearInstalledFrom1997: 'Från 1997 och framåt',
          floor: {
            area: 'Golvarea (m²)',
            uValue: 'Golv U-värde (W/m²K)',
            title: 'Golv',
            options: {
              title: 'Typ av golvmaterial',
              standard: 'Standard',
              tiles: 'Plattor (7 mm) + betong',
              flooringChipBoard: 'Golvbeläggning (4 mm) + 22 mm spånskiva',
              flooringConcrete: 'Golvbeläggning (4 mm) + betong',
              flooringLWA: 'Golvbeläggning (4 mm) + lättklinkerdäck',
              parquetChipBoard: 'Parkett (14 mm) + 22 mm spånskiva',
              parquetConcrete: 'Parkett (14 mm) + betong',
              parquetLWA: 'Parkett (14 mm) + lättklinkerdäck',
              carpetChipBoard: 'Matta (10 mm) + 22 mm spånskiva',
              carpetConcrete: 'Matta (10 mm) + betong',
              carpetLWA: 'Matta (10 mm) + lättklinkerdäck',
            },
          },
          roof: {
            title: 'Tak',
            optionsTitle: 'Takkonstruktion',
            area: 'Takarea (m²)',
            uValue: 'Tak U-värde (W/m²K)',
            options: [
              'Standard',
              'Kompakt tak med 200–250 mm betong, 200 mm isolering',
              'Kompakt tak med 200–250 mm betong, 250 mm isolering',
              'Kompakt tak med 200–250 mm betong, 300 mm isolering',
              'Kompakt tak med 200–250 mm betong, 350 mm isolering',
              'Kompakt tak med 200–250 mm betong, 400 mm isolering',
              'Kompakt tak med 200–250 mm betong, 450 mm isolering',
              'Kompakt tak med 200–250 mm betong, 500 mm isolering',
              'Kompakt tak med korrugerad stålplåt, 200 mm isolering',
              'Kompakt tak med korrugerad stålplåt, 250 mm isolering',
              'Kompakt tak med korrugerad stålplåt, 300 mm isolering',
              'Kompakt tak med korrugerad stålplåt, 350 mm isolering',
              'Kompakt tak med korrugerad stålplåt, 400 mm isolering',
              'Kompakt tak med korrugerad stålplåt, 450 mm isolering',
              'Kompakt tak med korrugerad stålplåt, 500 mm isolering',
              'Sadeltak med 48 mm takbjälkar (9 % areandel), 200 mm isolering',
              'Sadeltak med 48 mm takbjälkar (9 % areandel), 250 mm isolering',
              'Sadeltak med 48 mm takbjälkar (9 % areandel), 300 mm isolering',
              'Sadeltak med 48 mm takbjälkar (9 % areandel), 350 mm isolering',
              'Sadeltak med 48 mm takbjälkar (9 % areandel), 400 mm isolering',
              'Sadeltak med I-balkar (6 % areandel), 200 mm isolering',
              'Sadeltak med I-balkar (6 % areandel), 250 mm isolering',
              'Sadeltak med I-balkar (6 % areandel), 300 mm isolering',
              'Sadeltak med I-balkar (6 % areandel), 350 mm isolering',
              'Sadeltak med I-balkar (6 % areandel), 400 mm isolering',
              'Sadeltak med I-balkar (6 % areandel), 450 mm isolering',
              'Sadeltak med I-balkar (6 % areandel), 500 mm isolering',
              'Sadeltak med I-balkar (6 % areandel), 550 mm isolering',
              'Tak med kallvind, 48 mm bjälkar (9 % areandel), 200 mm isolering',
              'Tak med kallvind, 48 mm bjälkar (9 % areandel), 250 mm isolering',
              'Tak med kallvind, 48 mm bjälkar (9 % areandel), 300 mm isolering',
              'Tak med kallvind, 48 mm bjälkar (9 % areandel), 350 mm isolering',
              'Tak med kallvind, 48 mm bjälkar (9 % areandel), 400 mm isolering',
              'Tak med kallvind, 48 mm bjälkar (9 % areandel), 450 mm isolering',
              'Tak med kallvind, 48 mm bjälkar (9 % areandel), 500 mm isolering',
              'Tak med kallvind, 48 mm bjälkar (9 % areandel), 550 mm isolering',
            ],
          },
          basement: {
            title: 'Källare',
            area: 'Källararea (m²)',
            wallHeight: 'Vägg­höjd (m)',
            wallThickness: 'Väggtjocklek (m)',
            baseWallConstruction: 'Väggkonstruktion',
            wallUValue: 'U-värde (W/m²K)',
            heatStorage: 'Typ av värmelagring',
            effectiveHeatCapacity: 'Effektiv värmekapacitet (kJ/m²K)',
            floorConstruction: 'Golvkonstruktion',
            baseWallConstructionType: 'Väggkonstruktionstyp',
            baseWallConstructionOptions: [
              'Standard',
              '200 mm betong med 100 mm isolering',
              '200 mm betong med 150 mm isolering',
              '200 mm betong med 200 mm isolering',
              '200 mm betong med 250 mm isolering',
              '200 mm betong med 300 mm isolering',
              '300 mm betong med 100 mm isolering',
              '300 mm betong med 150 mm isolering',
              '300 mm betong med 200 mm isolering',
              '300 mm betong med 250 mm isolering',
              '300 mm betong med 300 mm isolering',
            ],
            heatStorageTypes: [
              'Ingen',
              'Lätt (< 50 Wh/m²K)',
              'Medel (50–100 Wh/m²K)',
              'Tung (100–150 Wh/m²K)',
              'Mycket tung (> 150 Wh/m²K)',
              '100 mm betong',
              '150 mm betong',
              '200 mm betong',
              '250 mm betong',
              '300 mm betong',
              'Trävirke',
              'Gips',
            ],
            floorConstructionTypes: [
              'Ingen',
              'Standard',
              'Betong på mark med 100 mm isolering',
              'Betong på mark med 150 mm isolering',
              'Betong på mark med 200 mm isolering',
              'Betong på mark med 250 mm isolering',
              'Betong på mark med 300 mm isolering',
              'Betong på mark med 350 mm isolering',
              'Betong på mark med 400 mm isolering',
              'Träbjälklag med 200 mm isolering',
              'Träbjälklag med 250 mm isolering',
              'Träbjälklag med 300 mm isolering',
            ],
          },
        },
        doors: {
          title: 'Dörrtyp',
          yearInstalled: 'Installationsår',
          totalArea: 'Total dörrarea',
          totalAreaFormula: 'Summa av alla dörrytor',
          avgUValue: 'Genomsnittligt U-värde (dörrar)',
          avgUValueFormula: '(Σ(U × area)) / Σ(area)',
          percentageOfFacade: 'Dörrarea som % av fasad',
          percentageOfFacadeFormula: 'Total dörrarea / Total fasadarea × 100',
          doorTypes: [
            'Ingen',
            'Standard',
            'Isolerad',
            'Normal',
            'Välisolerad',
            'Oisolerad',
          ],
        },
        gates: {
          title: 'Porttyp',
          yearInstalled: 'Installationsår',
          totalArea: 'Total portarea',
          totalAreaFormula: 'Summa av alla portytor',
          avgUValue: 'Genomsnittligt U-värde (portar)',
          avgUValueFormula: '(Σ(U × area)) / Σ(area)',
          percentageOfFacade: 'Portarea som % av fasad',
          percentageOfFacadeFormula: 'Total portarea / Total fasadarea × 100',
        },
        airLeakage: {
          airLeakageRate: 'Luftläckage (l/s·m² vid 50 Pa)',
          airChangeRate: 'Luftomsättningshastighet (ACH vid 50 Pa)',
          naturalVentilation: 'Naturlig ventilation',
        },
        thermalMass: {
          buildingHeatCapacity: 'Hela byggnadens värmekapacitet',
          heatCapacitySelectTitle: 'Byggnadstyp (NS 3031 B.2.8)',
          shortDescriptionFirstOption:
            'Lätt bjälklag, tunt golvbelägg, lätta väggar',
          shortDescriptionSecondOption:
            'Akustiskt undertak, matta över betong, lätta väggar',
          shortDescriptionThirdOption:
            'Lite exponerad betong (20 %), parkett över betong',
          shortDescriptionFourthOption: 'Huvudsakligen exponerad betong (70 %)',
          shortDescriptionFifthOption:
            'Exponerad betong i tak, väggar och golv',
          labelFirstOption: 'Mycket lätt byggnad',
          labelSecondOption: 'Lätt byggnad',
          labelThirdOption: 'Medel byggnad',
          labelFourthOption: 'Tung byggnad',
          labelFifthOption: 'Mycket tung byggnad',
          normalizedHeatCapacity: 'Normaliserad värmekapacitet [Wh/(m²·K)]',
          normalizedHeatCapacityHelper:
            'Från NS 3031 Tabell B.8 - Används i dynamisk energiberäkning',
          interiorWalls: 'Innerväggar',
          north: 'Norr',
          south: 'Söder',
          east: 'Öster',
          west: 'Väst',
          claddingTitle: 'Beklädnadstyp',
          cladding: [
            'Anpassad',
            'Standard',
            '100 mm (eller mer) betong',
            '80 mm betong',
            'Gasbetong',
            'Gips 13 mm',
            'Lätt tegel',
            'Lättklinker',
            'Massivträ (tjocklek över 40 mm)',
            'Träpanel 15 mm',
            'Tung (kompakt) tegel',
          ],
          claddingSubText: 'Användardefinierad',
          internalConstruction: 'Intern konstruktion',
          heatCapacity: 'Värmekapacitet [Wh/m²K]',
          grade: 'Klass',
          furniture: {
            title: 'Möbler',
            options: ['Ingen', 'Standard', 'Låg', 'Mellan', 'Hög'],
          },
          thermalHeatCapacityLabel: 'Termisk värmekapacitet',
          thermalHeatCapacityFormula:
            'BRA × normvärde / 1000 (Norm: Ingen = 0, Låg = 40, Mellan = 60, Hög = 80 Wh/m²K)',
          floorSeparationsAreaLabel: 'Bjälklagsarea (m²)',
          internalFloorsTooltip:
            'Invändiga bjälklag mellan våningsplan: BRA × (våningsantal − 1) / våningsantal',
        },
      },
    },
    report: {
      noReportYetTitle: 'Ingen rapport ännu',
      noReportYetDescription:
        'Skapa ett första rapportutkast för att komma igång med dokumentationen av besiktningen.',
      noReportYetSubDescription:
        'Rapporten kommer att innehålla kapitel, textfält och bilagor i ett strukturerat format.',
      creatingDraft: 'Skapar utkast…',
      createDraft: 'Skapa utkast',

      title: 'Rapport',
      reportGenerationHint1:
        'För att generera rapporten måste besiktningens status sättas till slutförd.',
      reportGenerationHint2: 'Rapporter genereras var femtonde minut.',
      reportGenerationHint3:
        'Data hämtas från besiktningen när statusen är satt till slutförd.',

      statusDraft: 'Utkast',
      statusAiGenerate: 'AI-generering',
      statusComplete: 'Slutförd',

      reportGenerationTitle: 'Rapportgenerering',
      reportGenerationLine1:
        'För att generera rapporten måste besiktningens status sättas till slutförd. Rapporter genereras var femtonde minut.',
      reportGenerationLine2:
        'Data hämtas från besiktningen när statusen är satt till slutförd.',

      tableOfContents: 'Innehållsförteckning',

      olderVersionWarning:
        'Varning! Du visar en äldre version av denna rapport.',

      saving: 'Sparar…',
      saveReport: 'Spara rapport',
      deleteReport: 'Ta bort rapport',

      confirmDeletionTitle: 'Bekräfta borttagning',
      confirmDeleteReportMessage:
        'Är du säker på att du vill ta bort denna rapport?',
      confirmDeleteTextFieldMessage:
        'Är du säker på att du vill ta bort detta textfält?',

      addField: 'Lägg till fält',
      fieldSingular: 'fält',
      fieldsPlural: 'fält',

      aiPrompt: 'AI-prompt',
      reportText: 'Rapporttext',
      attachments: 'Bilagor',
      addImage: 'Lägg till bild',

      aiLabel: 'AI',
      scoreLabel: 'Poäng',

      versionLabel: 'Version',

      exportToWord: 'Exportera till Word',
      exportingWord: 'Exporterar...',
      wordExportProgress: {
        starting: 'Startar export...',
        capturingCharts: 'Fångar diagram...',
        capturingDetails: 'Fångar beräkningsdetaljer...',
        buildingDocument: 'Bygger dokument...',
        savingFile: 'Sparar fil...',
        complete: 'Export klar',
        error: 'Export misslyckades. Försök igen.',
      },
    },
    UserCalendar: {
      createYourActivity: 'Skapa din aktivitet',
      categoryErrorMessage: 'Kategori saknas',
      titleErrorMessage: 'Titel saknas',
      createActivity: 'Skapa aktivitet',
      editActivity: 'Redigera aktivitet',
      confirmDeletion: 'Bekräfta radering',
      deleteMessage: 'Är du säker på att du vill radera denna aktivitet?',
    },
  },
  attachments: {
    notes: 'Anteckningar',
    description: 'Beskrivning',
    replaceImage: 'Byt bild',
    addImage: 'Lägg till bild',
    removeAttachment: 'Ta bort bilaga',
    tags: 'Etiketter',
    uploadImage: 'Ladda upp skärmbild',
  },
  buildingControlProfile: {
    inOperationTitle: 'I drift',
    outsideOperationTitle: 'Ur drift',
    temperatureLower: 'Nedre temperaturgräns (°C)',
    temperatureUpper: 'Övre temperaturgräns (°C)',
    humidityLower: 'Nedre fuktighetsgräns (%)',
    humidityUpper: 'Övre fuktighetsgräns (%)',
    co2Tooltip: 'Högsta tillåtna CO₂-nivå, mätt i ppm.',
    refreshInterval: 'Uppdateringsintervall',
    refreshIntervalHelp: 'Hur ofta ASPA kontrollerar dessa inställningar.',
    comfortWeight: 'Komfortvikt',
    energy: 'Energi',
    comfort: 'Komfort',
    costInfo:
      'Optimeraren balanserar energianvändning och komfort. Låg komfortvikt prioriterar låg energianvändning, medan hög komfortvikt prioriterar bättre komfort. Båda värdena beräknas på en skala från 0 till 1.',
  },
  gridRegions: {
    label: 'Elområde',
    placeholder: '- Välj område -',
    groups: {
      nordic: 'Norden',
      centralEurope: 'Centraleuropa',
      southernEurope: 'Sydeuropa',
      baltic: 'Baltikum',
      britishIsles: 'Brittiska öarna',
      easternEurope: 'Östeuropa',
    },
    areas: {
      NO1: 'Oslo / Östra Norge',
      NO2: 'Kristiansand / Södra Norge',
      NO3: 'Trondheim / Mellersta Norge',
      NO4: 'Tromsø / Norra Norge',
      NO5: 'Bergen / Västra Norge',
      SE1: 'Norra Sverige',
      SE2: 'Mellersta norra Sverige',
      SE3: 'Mellersta Sverige',
      SE4: 'Södra Sverige',
      DK1: 'Västra Danmark (Jylland-Fyn)',
      DK2: 'Östra Danmark (Själland)',
      FI: 'Finland',
      DE_LU: 'Tyskland-Luxemburg',
      AT: 'Österrike',
      BE: 'Belgien',
      NL: 'Nederländerna',
      FR: 'Frankrike',
      CH: 'Schweiz',
      CZ: 'Tjeckien',
      PL: 'Polen',
      SK: 'Slovakien',
      HU: 'Ungern',
      SI: 'Slovenien',
      HR: 'Kroatien',
      IT_NORTH: 'Italien norra',
      IT_CNORTH: 'Italien centrala norra',
      IT_CSOUTH: 'Italien centrala södra',
      IT_SOUTH: 'Italien södra',
      IT_SICILY: 'Italien Sicilien',
      IT_SARDINIA: 'Italien Sardinien',
      ES: 'Spanien',
      PT: 'Portugal',
      GR: 'Grekland',
      EE: 'Estland',
      LV: 'Lettland',
      LT: 'Litauen',
      GB: 'Storbritannien',
      IE_SEM: 'Irland (SEM)',
      RO: 'Rumänien',
      BG: 'Bulgarien',
      RS: 'Serbien',
      ME: 'Montenegro',
      AL: 'Albanien',
      MK: 'Nordmakedonien',
      BA: 'Bosnien och Hercegovina',
      XK: 'Kosovo',
    },
  },
  addressSearch: {
    label: 'Sök på adress',
    placeholder: 'Gata, nummer och ort',
    moreHint:
      'Visar {shown} av {total}. Lägg till ort eller postnummer för att begränsa sökningen.',
    noHitsHint:
      'Inga träffar. Lägg till husnummer och ort, till exempel Storgata 1 Oslo.',
  },
  energyLabelForm: {
    eyebrow: 'Energideklaration',
    language: 'Språk',
    themeLight: 'Byt till ljust tema',
    themeDark: 'Byt till mörkt tema',
    title: 'Energimärkning',
    loggedInAs: 'Inloggad som',
    logout: 'Logga ut',
    login: {
      title: 'Logga in',
      phoneDescription:
        'Logga in med det telefonnummer du använde när du beställde energideklarationen (Energiattest). En verifieringskod skickas via SMS.',
      codeDescription: 'Ange den sexsiffriga koden från SMS:et.',
      phone: 'Telefonnummer',
      phonePlaceholder: '70 123 45 67',
      countryCode: 'Landskod',
      phoneHint: 'Numret du angav när du beställde deklarationen.',
      code: 'Verifieringskod',
      codeHint: 'Sex siffror från SMS:et.',
      codeSentTo: 'Koden har skickats till',
      sendCode: 'Skicka kod',
      verify: 'Verifiera',
      changePhone: 'Använd ett annat telefonnummer',
    },
    flow: {
      navTitle: 'Så här går du vidare',
      draftSavedAt: 'Ditt utkast — senast sparat',
      continueLater: 'Du kan stänga och fortsätta senare.',
      draft: 'Utkast',
      saveAndClose: 'Spara och stäng',
      autosaved: 'Dina svar sparas automatiskt.',
      submitted: {
        title: 'Skickat',
        body: 'Tack. En energirådgivare går igenom dina svar.',
      },
      back: 'Tillbaka',
      next: 'Nästa',
      submit: 'Skicka in',
      stepsMenu: 'Steg',
      whyWeAsk: 'Varför frågar vi?',
      validation: {
        range: 'Måste vara mellan {min} och {max}.',
        min: 'Måste vara minst {min}.',
        max: 'Kan inte vara mer än {max}.',
        positive: 'Måste vara över noll.',
      },
      select: 'Välj',
      gnr: 'Gnr',
      bnr: 'bnr',
      buildingNumberShort: 'byggnadsnr',
      building: {
        address: 'Adress',
        buildingNumber: 'Byggnadsnr',
        cadastre: 'Gnr / bnr',
        buildingType: 'Byggnadstyp',
        usableArea: 'Bruksarea (BRA)',
        footprint: 'Byggnadsyta',
      },
      cadastre: {
        notFound:
          'Byggnaden hittades inte i fastighetsregistret. Fyll i det du vet.',
      },
      yesNo: { yes: 'Ja', no: 'Nej', dontKnow: 'Vet inte' },
      status: {
        completed: 'Slutfört',
        defaults: 'Standardvärden',
        notApplicable: 'Ej aktuellt',
      },
      steps: {
        confirmBuilding: {
          nav: 'Bekräfta byggnaden',
          title: 'Bekräfta byggnaden',
          eyebrow: 'Hittad via GPS och fastighetsregistret',
          question: 'Är det här din byggnad?',
          body: 'Vi har markerat byggnaden närmast din position. Kontrollera att adress och byggnadsnummer stämmer innan du går vidare.',
          wrongHint:
            'Stämmer det inte? Tryck på rätt byggnad i kartan, eller sök på adress.',
          searchAddress: 'Sök på adress',
          mapTitle: 'Byggnadsväljare',
          noBuilding:
            'Hittade ingen byggnad här. Dra markören närmare byggnaden.',
        },
        aboutBuilding: {
          nav: 'Om byggnaden',
          title: 'Om byggnaden',
          lead: 'Det mesta nedan är hämtat från fastighetsregistret. Rätta det som inte stämmer — deklarationen bygger på dessa siffror.',
          aside: {
            title: 'Kategori, byggår och yta',
            body: 'Byggnadskategori, byggår och bruksarea är grunden för hela beräkningen. Kategorin styr standardvärdena, byggåret säger vilka byggregler som gällde, och ytan avgör hur mycket energi byggnaden använder per kvadratmeter.',
          },
          sections: {
            category: {
              title: 'Byggnadskategori',
              description:
                'Kategorin styr vilka standardvärden som används längre fram.',
            },
            area: {
              title: 'Area och höjd',
              description: 'Byggnadsytan kan också läsas av från kartan.',
            },
          },
          fields: {
            category: {
              label: 'Kategori',
              hint: 'Hämtad från fastighetsregistret när byggnaden finns där.',
            },
            subcategory: {
              label: 'Underkategori',
              hint: 'Hämtad från fastighetsregistret när byggnaden finns där.',
            },
            buildYear: {
              label: 'Byggår',
              hint: 'Året bygget påbörjades, om det finns.',
            },
            floors: {
              label: 'Antal våningar',
              hint: 'Ovan mark. Källare läggs till senare.',
            },
            footprint: {
              label: 'Byggnadsyta',
              hint: 'Från fastighetsregistret eller kartan.',
            },
            usableArea: {
              label: 'Total bruksarea (BRA)',
              hint: 'Samlad golvyta för alla våningar, mätt innanför ytterväggarna.',
            },
            heatedArea: {
              label: 'Uppvärmd bruksarea',
              hint: 'Arean som värms upp till över 15 °C.',
            },
            floorHeight: {
              label: 'Genomsnittlig våningshöjd',
              hint: 'Lämna tomt om du inte vet, då används standardvärdet för kategorin.',
            },
          },
          options: {
            categories: {
              kontor: 'Kontorsbyggnad',
              lettIndustri: 'Lätt industri',
              lager: 'Lagerbyggnad',
              forretning: 'Affärsbyggnad',
              skole: 'Skolbyggnad',
              hotell: 'Hotellbyggnad',
            },
            subcategories: {
              lettindustriLager: 'Lätt industri och lager',
              verksted: 'Verkstad',
              produksjon: 'Produktionshall',
            },
          },
          knowMore: 'Vet du mer om ytorna?',
        },
        envelope: {
          nav: 'Klimatskal',
          title: 'Klimatskal',
          lead: 'Hur ytterväggarna är byggda avgör hur mycket värme byggnaden förlorar. Välj det som liknar mest.',
          sections: {
            walls: {
              title: 'Ytterväggar',
              description:
                'Material och tjocklek avgör hur mycket värme väggarna släpper ut.',
            },
            more: {
              title: 'Vad mer har byggnaden?',
              description: 'Det du bockar för här öppnar egna steg i menyn.',
            },
          },
          fields: {
            construction: {
              label: 'Konstruktion',
              hint: 'Den vanligaste typen om det finns flera.',
            },
            insulation: {
              label: 'Isoleringstjocklek',
              hint: 'Lämna tomt om du inte vet — vi använder byggårets standard.',
            },
          },
          options: {
            walls: {
              tre: 'Trä',
              mur: 'Murverk',
              staal: 'Stål',
              betong: 'Betong',
            },
            concrete: { betong10: '10 cm', betong20: '20 cm' },
          },
          checks: {
            basement: { label: 'Källare eller souterrängvåning' },
            knowWindows: { label: 'Fönster' },
            doors: { label: 'Dörrar' },
            gates: { label: 'Portar' },
          },
          aside: {
            title: 'Väggar och värmeförlust',
            body: 'Mycket av värmen i en byggnad försvinner ut genom väggarna. Material och isolering berättar för rådgivaren hur väl byggnaden håller kvar värmen. Välj det som liknar mest, så räknar rådgivaren ut resten.',
          },
        },
        basement: {
          nav: 'Källare',
          title: 'Källare',
          lead: 'Källarvåningen beräknas annorlunda eftersom den gränsar mot marken och inte mot uteluft.',
          aside: {
            title: 'Källare mot mark',
            body: 'En källare gränsar mot marken, inte mot uteluften. Marken håller jämnare temperatur över året, så värmeförlusten beräknas annorlunda än för väggar ovan mark. Om källaren är uppvärmd avgör om den räknas med i den uppvärmda ytan. Fyll i det du vet, tomma fält får standardvärden.',
          },
          section: {
            title: 'Källarvåningen',
            description: 'Bara det du vet. Tomma fält får standardvärden.',
          },
          checks: {
            heated: {
              label: 'Källarvåningen är uppvärmd',
              description: 'Ouppvärmd källare räknas som buffert mot marken.',
            },
          },
          fields: {
            floorArea: { label: 'Golvyta källare' },
            wallLength: { label: 'Längd ytterväggar' },
            floorHeight: { label: 'Våningshöjd' },
            wallThickness: { label: 'Källarväggens tjocklek' },
            depth: {
              label: 'Genomsnittligt djup under marknivå',
              hint: 'Hur djupt källaren ligger i terrängen.',
            },
          },
          knowMore: 'Vet du mer om källaren?',
        },
        windows: {
          nav: 'Fönster',
          title: 'Fönster',
          lead: 'Fönstren står för en stor del av värmeförlusten — och solvärmen. Fördelningen per väderstreck betyder mest.',
          sections: { area: { title: 'Fönstren i byggnaden' } },
          checks: {
            even: {
              label: 'Alla fönster är jämnt fördelade över byggnaden',
              description: 'Vi delar den totala arean lika på fyra fasader.',
            },
          },
          fields: {
            windowType: {
              label: 'Fönstertyp',
              hint: 'Den vanligaste typen om det finns flera.',
            },
            totalArea: { label: 'Total fönsterarea' },
            installYear: {
              label: 'Installationsår fönster',
              hint: 'Året de nyaste fönstren sattes in.',
            },
            north: { label: 'Norr' },
            east: { label: 'Öster' },
            south: { label: 'Söder' },
            west: { label: 'Väster' },
          },
          aside: {
            title: 'Väderstreck',
            body: 'Fönster mot söder släpper in mest solvärme och minskar uppvärmningsbehovet. Mot norr är det nästan bara värmeförlust. Därför frågar vi per fasad.',
          },
          knowMore: 'Vet du mer om fönstren?',
        },
        doors: {
          nav: 'Dörrar och portar',
          title: 'Dörrar och portar',
          lead: 'Dörrar och portar är en del av klimatskalet, och typen säger mycket om värmeförlusten. Fyll i det du vet eller minns, resten får standardvärden.',
          only: {
            doors: {
              nav: 'Dörrar',
              title: 'Dörrar',
              lead: 'Ytterdörrarna är en del av klimatskalet, och typen säger mycket om värmeförlusten. Fyll i det du vet eller minns, resten får standardvärden.',
              aside: {
                title: 'Dörrar och värmeförlust',
                body: 'En ytterdörr släpper ut mer värme än väggen runt omkring. Dörrtypen berättar för rådgivaren ungefär hur väl den isolerar. Det du inte vet räknar rådgivaren ut från byggåret och standardvärden.',
              },
            },
            gates: {
              nav: 'Portar',
              title: 'Portar',
              lead: 'Portar är ofta de största öppningarna i klimatskalet, och typen säger mycket om värmeförlusten. Fyll i det du vet eller minns, resten får standardvärden.',
              aside: {
                title: 'Portar och värmeförlust',
                body: 'Portar är ofta de största öppningarna i byggnaden, och de står gärna öppna i perioder. Porttypen berättar för rådgivaren ungefär hur väl de isolerar. Det du inte vet räknar rådgivaren ut från byggåret och standardvärden.',
              },
            },
          },
          aside: {
            title: 'Dörrar, portar och värmeförlust',
            body: 'Dörrar och portar släpper ut mer värme än väggen runt omkring, och portar står gärna öppna i perioder. Typen berättar för rådgivaren ungefär hur väl de isolerar. Det du inte vet räknar rådgivaren ut från byggåret och standardvärden.',
          },
          sections: {
            doors: {
              title: 'Dörrar',
              description: 'Ytterdörrar för personer.',
            },
            gates: {
              title: 'Portar',
              description: 'Fordonsportar, lastportar och liknande.',
            },
          },
          fields: {
            doorType: {
              label: 'Dörrtyp',
              hint: 'Den vanligaste typen om det finns flera.',
            },
            installYear: { label: 'Installationsår' },
            uValue: {
              label: 'U-värde, genomsnitt',
              hint: 'Lämna tomt om du inte vet.',
            },
            gateType: {
              label: 'Porttyp',
              hint: 'Den vanligaste typen om det finns flera.',
            },
            area: { label: 'Yta' },
          },
          options: {
            doorTypes: {
              isolertStaal: 'Ståldörr',
              glass: 'Glasdörr',
              tre: 'Trädörr',
              aluminium: 'Aluminiumdörr',
            },
            gateTypes: {
              leddportIsolert: 'Isolerad takskjutport',
              leddport: 'Oisolerad takskjutport',
              rulleport: 'Rullport',
              hurtigport: 'Snabbport',
            },
          },
          knowMoreDoors: 'Vet du mer om dörrarna?',
          knowMoreGates: 'Vet du mer om portarna?',
        },
        energySources: {
          nav: 'Energikällor',
          title: 'Energikällor',
          lead: 'Vilka energikällor har byggnaden? Valen här öppnar de nästa stegen.',
          sections: {
            delivered: {
              title: 'Levererad energi',
              description: 'Bocka för allt som är anslutet till byggnaden.',
            },
            own: { title: 'Egen produktion' },
          },
          checks: {
            electricity: {
              label: 'Elektricitet',
              description:
                'Alla byggnader har el. Enbart el ger en förenklad beräkning.',
            },
            districtHeating: {
              label: 'Fjärrvärme',
              description: 'Öppnar steget Centralvärmeanläggning.',
            },
            heatPump: {
              label: 'Värmepump',
              description: 'Öppnar steget Värmepump.',
            },
            fossil: {
              label: 'Olja, gas eller bio',
              description: 'Öppnar steget Förbränningspanna.',
            },
            other: {
              label: 'Andra energikällor',
              description: 'Beskriv i kommentarsfältet i sista steget.',
            },
            solar: {
              label: 'Byggnaden har solcellsanläggning',
              description: 'Öppnar steget Solceller.',
            },
          },
          aside: {
            title: 'Centralvärme',
            body: 'Fjärrvärme, värmepump och pannor kan alla vara anslutna till en centralvärmeanläggning. I nästa steg frågar vi hur de delar på uppvärmning och varmvatten.',
          },
        },
        centralHeating: {
          nav: 'Centralvärmeanläggning',
          title: 'Centralvärmeanläggning',
          lead: 'Valda energikällor — så här är de uppsatta i centralvärmeanläggningen.',
          sections: {
            plant: { title: 'Anläggningen' },
            districtHeating: {
              title: 'Fjärrvärme',
              description: 'Så används fjärrvärmen i byggnaden.',
            },
          },
          fields: {
            location: { label: 'Placering', hint: 'Var centralen står.' },
            installYear: { label: 'Installationsår' },
            connectedTo: {
              label: 'Ansluten till',
              hint: 'Vart vattnet går.',
            },
          },
          options: {
            locations: {
              tekniskRom: 'Teknikrum',
              kjeller: 'Källare',
              tak: 'Tak',
              egetBygg: 'Egen byggnad',
            },
            connections: {
              oppvarming: 'Uppvärmning',
              oppvarmingVent: 'Uppvärmning och ventilation',
            },
          },
          checks: {
            forHeating: { label: 'Rumsuppvärmning' },
            forHotWater: { label: 'Tappvarmvatten' },
          },
          aside: {
            title: 'Värmen fördelas från centralen',
            body: 'Centralvärmesystemet för värmen från energikällorna ut i byggnaden som vatten. Var centralen står, och om vattnet även värmer ventilationsluften, avgör hur mycket värme som går förlorad på vägen. Saknar du uppgifterna använder vi standardvärden.',
          },
        },
        heatPump: {
          nav: 'Värmepump',
          title: 'Värmepump',
          lead: 'Typ och prestanda på värmepumpen. Effekt och förbrukning står vanligtvis på typskylten eller i servicehäftet.',
          sections: {
            plant: { title: 'Anläggningen' },
            connection: { title: 'Anslutning' },
          },
          fields: {
            type: { label: 'Typ' },
            installYear: { label: 'Installationsår' },
            power: {
              label: 'Effekt',
              hint: 'Nominell värmeeffekt från typskylten.',
            },
            annualUse: {
              label: 'Årlig förbrukning',
              hint: 'Från elmätare eller styrsystem, om det finns.',
            },
          },
          options: {
            types: {
              luftLuft: 'Luft–luft',
              luftVann: 'Luft–vatten',
              vaeskeVann: 'Vätska–vatten',
              avtrekk: 'Frånluftsvärmepump',
            },
          },
          checks: {
            connected: {
              label: 'Värmepumpen är ansluten till centralvärmeanläggningen',
              description: 'Andelen sätts i steget Uppvärmning och kyla.',
            },
          },
          knowMore: 'Vet du mer om värmepumpen?',
          aside: {
            title: 'Mer värme än el',
            body: 'En värmepump hämtar värme från luft, vatten eller mark och ger fler kilowattimmar värme än den använder i el. Typ, effekt och ålder avgör hur effektiv den är, och det slår direkt igenom i energiklassen. Saknar du siffrorna använder vi standardvärden.',
          },
        },
        boiler: {
          nav: 'Förbränningspanna',
          title: 'Förbränningspanna',
          lead: 'Pannan som eldas med olja, gas eller biomassa. Effekten står vanligtvis på typskylten.',
          sections: { plant: { title: 'Pannan' } },
          fields: {
            fuelType: { label: 'Panntyp' },
            power: {
              label: 'Effekt vid full last',
              hint: 'Från typskylten eller dokumentationen.',
            },
          },
          options: {
            fuelTypes: { olje: 'Olja', gass: 'Gas', bio: 'Biomassa' },
          },
          aside: {
            title: 'Bränslet räknas olika',
            body: 'Olja, gas och biomassa viktas olika i energideklarationen, så panntypen påverkar både energiklassen och uppvärmningsbetyget. Effekten visar hur stor del av värmebehovet pannan kan täcka. Saknar du siffrorna använder vi standardvärden.',
          },
        },
        solar: {
          nav: 'Solceller',
          title: 'Solceller',
          lead: 'Egenproducerad el dras av från levererad energi i deklarationen.',
          sections: {
            plant: {
              title: 'Solcellsanläggningen',
              description:
                'Siffrorna finns vanligtvis i dokumentationen från leverantören eller i anläggningens app.',
            },
            hotWater: { title: 'Varmvatten' },
          },
          fields: {
            installedPower: {
              label: 'Installerad effekt',
              hint: 'Står i anläggningsdokumentationen.',
            },
            installYear: { label: 'Installationsår' },
            annualProduction: {
              label: 'Årlig produktion',
              hint: 'Från växelriktaren eller anläggningens app.',
            },
            panelArea: { label: 'Panelarea' },
          },
          checks: {
            hotWaterConnected: {
              label: 'Varmvatten är anslutet till centralanläggningen',
              description:
                'Se energikällor. Annars räknas varmvatten som elektriskt.',
            },
          },
          aside: {
            title: 'Egen el räknas positivt',
            body: 'Elen från solcellerna täcker en del av det byggnaden använder, och det kan ge en bättre energimärkning. Därför behöver vi veta hur stor anläggningen är. Saknar du siffrorna, skriv det i kommentarsfältet i sista steget.',
          },
          knowMore: 'Vet du mer om solcellsanläggningen?',
        },
        ventilation: {
          nav: 'Ventilation',
          systemTitle: 'Aggregat {number}',
          title: 'Ventilation',
          lead: 'Har byggnaden ventilationsaggregat?',
          sections: {
            type: {
              title: 'Ventilationsaggregat',
              description:
                'Bara balanserad ventilation behöver fler uppgifter.',
            },
            plant: {
              title: 'Anläggningen',
              description:
                'Ett aggregat blåser in frisk luft och drar ut använd luft, ofta med värmeåtervinning.',
            },
            capacity: {
              title: 'Kapacitet — per aggregat',
              description:
                'Är kapaciteten större än minimivärdet måste den anges.',
            },
            maintenance: { title: 'Underhåll' },
          },
          fields: {
            hasSystems: { label: 'Har byggnaden ventilationsaggregat?' },
            count: {
              label: 'Antal aggregat',
              hint: 'Du får en uppsättning fält per aggregat.',
            },
            type: { label: 'Typ' },
            installYear: { label: 'Installationsår' },
            airflowOperating: { label: 'Luftflöde under drifttid' },
            airflowOff: { label: 'Luftflöde utanför drifttid' },
            lastMaintenance: {
              label: 'Senaste underhållsdatum',
              hint: 'Från servicerapporten.',
            },
            regularMaintenance: {
              label: 'Regelbundet underhåll av aggregatet?',
            },
            moreInfo: {
              label: 'Har du mer information till rådgivaren om ventilationen?',
              hint: 'Filterbyte, drifttider, kända avvikelser.',
            },
            heatRecovery: {
              label: 'Värmeåtervinningsgrad',
              hint: 'Från aggregatets dokumentation.',
            },
          },
          checks: {
            exhaustHeatPump: {
              label: 'Avluftsvärmepump ansluten till centralen',
            },
            extractHeatPump: {
              label: 'Frånluftsvärmepump ansluten till centralen',
            },
          },
          options: {
            types: {
              avtrekk: 'Mekanisk frånluft',
              balansert: 'Balanserad ventilation',
            },
            typeDescriptions: {
              avtrekk: 'Stora delar av byggnaden har mekanisk frånluft.',
            },
          },
          aside: {
            title: 'Luft och värme',
            body: 'Ventilationen byter ut använd inneluft mot frisk uteluft. Ett aggregat som återvinner värmen ur luften som går ut sparar mycket energi. Saknar du siffrorna använder vi standardvärden.',
          },
          knowMore: 'Vet du mer om ventilationen?',
        },
        heating: {
          nav: 'Uppvärmning och kyla',
          title: 'Uppvärmning och kyla',
          lead: 'Förslagen nedan bygger på de energikällor och den ventilation du valde. Fyll i andelen varje lösning täcker, om du vet den.',
          groups: {
            electric: { title: 'Elektrisk uppvärmning' },
            central: { title: 'Centralvärme' },
          },
          options: {
            electric: {
              panelHeaters: 'Panelelement',
              convectors: 'Konvektorer',
              electricBoiler: 'Elpanna med varmvattentank',
              electricFloor: 'Golvvärme',
              ventilationHeat: 'Ventilationsvärme',
              airToAir: 'Värmepump luft–luft',
            },
            central: {
              radiators: 'Radiatorer',
              convectors: 'Konvektorer',
              waterFloor: 'Golvvärme',
              ventilationHeat: 'Ventilationsvärme',
            },
          },
          sections: { cooling: { title: 'Kyla' } },
          checks: {
            hasCooling: {
              label: 'Byggnaden har kyla',
              description: 'Kylmaskin, fjärrkyla eller värmepump i kylläge.',
            },
          },
          aside: {
            title: 'Fyll i det du vet',
            body: 'Om du inte vet behöver du inte fylla i fälten. Fyll i det du vet, vet något om eller ungefärliga värden. Fler detaljer ger energirådgivaren ett bättre underlag.',
          },
          singleShare: 'Vi antar att denna täcker hela uppvärmningen.',
        },
        summary: {
          nav: 'Sammanfattning och inskick',
          title: 'Sammanfattning och inskick',
          lead: 'Energideklarationen blir mer exakt — och ofta bättre — när fler fält är ifyllda.',
          alert: {
            title: '{count} steg använder standardvärden',
            body: 'Bristfälligt underlag gör att energimärkningen genomförs på begränsad information. Delar av tekniska system och byggnad beräknas då enligt standardvärden. Du kan skicka in nu eller gå tillbaka och fylla i mer för en mer exakt märkning.',
          },
          registered: 'Det du har registrerat',
          confirmFirst:
            'Bekräfta att uppgifterna är lämnade i god tro innan du skickar in.',
          sections: { advisor: { title: 'Till rådgivaren' } },
          fields: {
            note: {
              label:
                'Är det något rådgivaren bör veta om energiflöde och förbrukning?',
              hint: 'Till exempel: delar av byggnaden står tomma, natt- och helgsänkning, nyliga utbyten, kända läckage.',
            },
          },
          checks: {
            goodFaith: {
              label:
                'All information är registrerad efter bästa förståelse och i god tro',
              description:
                'Rådgivaren använder dina svar som underlag för energideklarationen. Du kan rätta senare om något var fel.',
            },
          },
          aside: {
            eyebrow: 'Vad händer nu?',
            title: 'Din registrering går till rådgivaren',
            body: 'En energirådgivare går igenom dina svar och skickar energideklarationen till Enova. Ingen behöver besöka byggnaden. Du får besked när deklarationen är klar.',
          },
        },
      },
      knowInstallYear: 'Vet du installationsåret?',
      assumeBuildYear: 'Vi antar att det är från {year}.',
      buildYearWord: 'byggåret',
      assumeStandard: 'Vi antar standardvärden.',
    },
  },
};

export default SWEDISH;
